import React, { useState, useEffect, Fragment } from 'react';
import {
  Grid,
  Card,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Chip,
  LinearProgress,
  Box,
  Typography,
  Paper,
  AppBar,
  Toolbar,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Divider,
  IconButton,
  Badge,
  Menu,
  MenuItem,
  TextField,
  Button,
  Collapse,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  Alert
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Group as GroupIcon,
  LocationOn as LocationIcon,
  Devices as DevicesIcon,
  Assessment as ReportsIcon,
  Notifications as NotificationsIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
  Search as SearchIcon,
  AccountCircle as AccountIcon,
  Menu as MenuIcon,
  ExpandLess,
  ExpandMore,
  Upload as UploadIcon,
  CloudUpload as CloudUploadIcon,
  Edit as EditIcon,
  Refresh as RefreshIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import './SchoolDashboard.css';
import {
  commissionHeaders,
  getCommissionUnlockToken,
  verifyCommissionOtp,
  clearCommissionUnlock
} from '../../utils/commissionUnlock';

let API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3002/api';
if (typeof window !== 'undefined' && window.location.protocol === 'https:' && API_BASE_URL.startsWith('http://')) {
  API_BASE_URL = API_BASE_URL.replace('http://', 'https://');
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const SELECT_MENU_PROPS = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const DEFAULT_STUDENT_FORM = {
  firstName: '',
  lastName: '',
  academicYear: '2024-25',
  classId: '',
  divisionId: '',
  rollNumber: '',
  teacherId: '',
  parentMobile1: '',
  parentMobile2: '',
  deviceId: '',
  devicePackageId: '',
  parentEmail: '',
  parentName: ''
};

const SchoolDashboard = ({ user, onLogout }) => {
  const [students, setStudents] = useState([]);
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const [activeSubmenu, setActiveSubmenu] = useState('all-devices');
  const [commissionOtpOpen, setCommissionOtpOpen] = useState(false);
  const [commissionOtp, setCommissionOtp] = useState('');
  const [commissionOtpError, setCommissionOtpError] = useState('');
  const [pendingCommissionNav, setPendingCommissionNav] = useState(null);
  const [teacherForm, setTeacherForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    standard: '',
    division: ''
  });
  const [teacherSaving, setTeacherSaving] = useState(false);
  const [teacherMessage, setTeacherMessage] = useState('');
  const [expandedMenus, setExpandedMenus] = useState({});
  const [loading, setLoading] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [teachers, setTeachers] = useState([]);
  const [classes, setClasses] = useState([]);
  const [standards, setStandards] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [devicePackages, setDevicePackages] = useState([]);
  const [devices, setDevices] = useState([]);
  const [editingDevice, setEditingDevice] = useState(null);
  const [filters, setFilters] = useState({
    search: '',
    standard: '',
    division: '',
    status: '',
    batteryLevel: ''
  });
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [changePasswordDialog, setChangePasswordDialog] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });


  const [studentForm, setStudentForm] = useState(() => ({ ...DEFAULT_STUDENT_FORM }));
  const [editingStudentId, setEditingStudentId] = useState(null);

  const [assignmentForm, setAssignmentForm] = useState({
    deviceId: '',
    studentId: ''
  });

  const [importFile, setImportFile] = useState(null);
  const [importingStudents, setImportingStudents] = useState(false);
  const [importSummary, setImportSummary] = useState(null);
  const [importErrors, setImportErrors] = useState([]);

  const [assignmentFilters, setAssignmentFilters] = useState({
    deviceSearch: '',
    studentSearch: '',
    division: '',
    deviceType: ''
  });

  const [connectedFilters, setConnectedFilters] = useState({
    studentSearch: '',
    division: ''
  });

  const [deviceFilters, setDeviceFilters] = useState({
    search: '',
    type: '',
    status: ''
  });

  const [subscriptions, setSubscriptions] = useState([]);
  const [payments, setPayments] = useState([]);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [paymentForm, setPaymentForm] = useState({
    studentId: '',
    amount: '',
    paymentMethod: 'cash',
    planId: '',
    paymentDate: new Date().toISOString().split('T')[0],
    baseAmount: '',
    taxAmount: '',
    totalAmount: ''
  });

  const TAX_PERCENTAGE = parseFloat(process.env.REACT_APP_TAX_PERCENTAGE) || 18;

  const calculateTax = (baseAmount) => {
    const normalizedBase = parseFloat(baseAmount) || 0;
    const tax = (normalizedBase * TAX_PERCENTAGE) / 100;
    const total = normalizedBase + tax;
    return { base: normalizedBase, tax, total };
  };

  const handleStudentImportFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      setImportFile(null);
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert('File exceeds 5 MB limit.');
      return;
    }

    setImportFile(file);
    setImportSummary(null);
    setImportErrors([]);
  };

  const handleImportStudentsUpload = async () => {
    if (!importFile) {
      alert('Please choose a file before importing.');
      return;
    }

    try {
      setImportingStudents(true);
      setImportSummary(null);
      setImportErrors([]);

      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('file', importFile);

      const response = await fetch(`${API_BASE_URL}/school/students/import`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        setImportSummary(data.summary || null);
        setImportErrors(data.summary?.errors || []);
        alert(data.message || 'Import completed successfully');
        loadStudents();
      } else {
        const errors = data.summary?.errors || (data.message ? [{ row: '-', message: data.message }] : []);
        setImportErrors(errors);
        alert(data.message || 'Failed to import students');
      }
    } catch (error) {
      console.error('Error importing students:', error);
      alert('Network error during import. Please try again.');
    } finally {
      setImportingStudents(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    
    if (passwordForm.new_password !== passwordForm.confirm_password) {
      alert('New password and confirm password do not match');
      return;
    }
    
    if (passwordForm.new_password.length < 6) {
      alert('Password must be at least 6 characters long');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/auth/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          current_password: btoa(passwordForm.current_password),
          new_password: btoa(passwordForm.new_password)
        })
      });

      const data = await response.json();

      if (response.ok) {
        alert('Password changed successfully');
        setChangePasswordDialog(false);
        setPasswordForm({
          current_password: '',
          new_password: '',
          confirm_password: ''
        });
      } else {
        alert(data.message || 'Failed to change password');
      }
    } catch (error) {
      console.error('Error changing password:', error);
      alert('Network error. Please try again.');
    }
  };

  const [paymentFilters, setPaymentFilters] = useState({
    studentSearch: '',
    division: ''
  });

  const [paymentReports, setPaymentReports] = useState([]);
  const [commissionSummary, setCommissionSummary] = useState({
    total_accrued: 0,
    total_pending: 0,
    total_paid: 0,
    transaction_count: 0,
    available_balance: 0,
    total_withdrawn: 0,
    commission_rate: 0,
    commission_type: 'percentage'
  });

  const formatCommissionRate = (summary) => {
    const type = summary?.commission_type === 'fixed' ? 'fixed' : 'percentage';
    const first = Number(summary?.first_purchase_rate ?? summary?.commission_rate ?? 0);
    const renewal = Number(summary?.renewal_rate ?? summary?.commission_rate ?? 0);
    const fmt = (rate) => (type === 'fixed' ? `₹${rate}` : `${rate}%`);
    return `First ${fmt(first)} / Renewal ${fmt(renewal)}`;
  };
  const [commissionReports, setCommissionReports] = useState([]);
  const [commissionTransactions, setCommissionTransactions] = useState([]);
  const [withdrawalForm, setWithdrawalForm] = useState({
    account_holder_name: '',
    account_number: '',
    ifsc_code: '',
    bank_name: '',
    amount: '',
    notes: ''
  });
  const [withdrawalLoading, setWithdrawalLoading] = useState(false);
  const [withdrawalMessage, setWithdrawalMessage] = useState('');
  const [commissionFilters, setCommissionFilters] = useState({
    start_date: '',
    end_date: '',
    standard: '',
    division: '',
    group_by: 'detail'
  });
  const [deviceSalesReports, setDeviceSalesReports] = useState([]);
  const [deviceSalesSummary, setDeviceSalesSummary] = useState({
    total_devices: 0,
    sold_to_student: 0,
    school_inventory: 0
  });
  const [deviceSalesFilters, setDeviceSalesFilters] = useState({
    standard: '',
    division: '',
    assignment_status: ''
  });
  const [paymentDetailsDialog, setPaymentDetailsDialog] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [parentDialog, setParentDialog] = useState(false);
  const [parentForm, setParentForm] = useState({
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    address: '',
    password: ''
  });
  const [parentExists, setParentExists] = useState(false);
  const [parentAccounts, setParentAccounts] = useState([]);
  const [selectedParent, setSelectedParent] = useState(null);
  const [resetPasswordDialog, setResetPasswordDialog] = useState(false);
  const [resetPasswordForm, setResetPasswordForm] = useState({
    parentId: '',
    parentName: '',
    newPassword: ''
  });
  const [notificationDialog, setNotificationDialog] = useState(false);
  const [notificationForm, setNotificationForm] = useState({
    title: '',
    message: '',
    type: 'info',
    selectedParents: []
  });
  const [createParentForm, setCreateParentForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    password: '',
    selectedStudents: []
  });
  const [studentFilters, setStudentFilters] = useState({
    search: '',
    standard: '',
    division: ''
  });
  const [parentFilters, setParentFilters] = useState({
    search: '',
    status: ''
  });
  const [assignStudentsForm, setAssignStudentsForm] = useState({
    parentId: '',
    selectedStudents: [],
    searchTerm: '',
    parentSearchTerm: ''
  });
  const [editParentDialog, setEditParentDialog] = useState(false);
  const [editParentForm, setEditParentForm] = useState({
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    status: 'active',
    assignedStudents: []
  });

  const loadSubscriptionPlans = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/subscription-plans`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const plans = await response.json();
        setSubscriptionPlans(plans);
      } else {
        console.error('Failed to load subscription plans:', response.status);
        setSubscriptionPlans([]);
      }
    } catch (error) {
      console.error('Error loading subscription plans:', error);
      setSubscriptionPlans([]);
    }
  };

  const loadPaymentReports = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/payment-reports`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const reports = await response.json();
        const paymentsArray = reports.payments || reports;
        setPaymentReports(paymentsArray);
      } else {
        console.error('Failed to load payment reports:', response.status);
      }
    } catch (error) {
      console.error('Error loading payment reports:', error);
    }
  };

  const loadCommissionSummary = async (filtersOverride = null) => {
    try {
      const token = localStorage.getItem('authToken');
      const filters = filtersOverride || commissionFilters;
      const params = new URLSearchParams();
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      if (filters.standard) params.append('standard', filters.standard);
      if (filters.division) params.append('division', filters.division);

      const headers = commissionHeaders({ Authorization: `Bearer ${token}` });

      const response = await fetch(`${API_BASE_URL}/school/commissions/summary?${params}`, { headers });
      let summary = {};
      if (response.ok) {
        const data = await response.json();
        summary = data.summary || {};
      } else if (response.status === 403) {
        clearCommissionUnlock();
        setActiveMenu('dashboard');
        setCommissionOtpOpen(true);
        return;
      }

      // Optional dedicated rate endpoint (newer backend); summary already includes per-school rate
      let rateSettings = {};
      const settingsResponse = await fetch(`${API_BASE_URL}/school/commission-settings`, { headers });
      if (settingsResponse.ok) {
        rateSettings = await settingsResponse.json();
      } else if (settingsResponse.status === 403) {
        clearCommissionUnlock();
        setActiveMenu('dashboard');
        setCommissionOtpOpen(true);
        return;
      }

      setCommissionSummary({
        total_accrued: summary.total_accrued ?? 0,
        total_pending: summary.total_pending ?? 0,
        total_paid: summary.total_paid ?? 0,
        transaction_count: summary.transaction_count ?? 0,
        available_balance: summary.available_balance ?? summary.total_pending ?? 0,
        total_withdrawn: summary.total_withdrawn ?? summary.total_paid ?? 0,
        commission_rate: rateSettings.commission_rate ?? summary.commission_rate ?? 0,
        commission_type: rateSettings.commission_type ?? summary.commission_type ?? 'percentage',
        first_purchase_rate: rateSettings.first_purchase_rate ?? summary.first_purchase_rate,
        renewal_rate: rateSettings.renewal_rate ?? summary.renewal_rate,
        school_id: rateSettings.school_id ?? summary.school_id,
        school_name: rateSettings.school_name ?? summary.school_name
      });
    } catch (error) {
      console.error('Error loading commission summary:', error);
    }
  };

  const loadCommissionTransactions = async (filtersOverride = null) => {
    try {
      const token = localStorage.getItem('authToken');
      const filters = filtersOverride || commissionFilters;
      const params = new URLSearchParams();
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);

      const response = await fetch(`${API_BASE_URL}/school/commissions/transactions?${params}`, {
        headers: commissionHeaders({ Authorization: `Bearer ${token}` })
      });
      if (response.status === 403) {
        clearCommissionUnlock();
        setActiveMenu('dashboard');
        setCommissionOtpOpen(true);
        return;
      }
      if (response.ok) {
        const data = await response.json();
        setCommissionTransactions(data.transactions || []);
        if (data.available_balance != null) {
          setCommissionSummary((prev) => ({
            ...prev,
            available_balance: data.available_balance,
            total_pending: data.available_balance
          }));
        }
      }
    } catch (error) {
      console.error('Error loading commission transactions:', error);
    }
  };

  const submitCommissionWithdrawal = async () => {
    setWithdrawalMessage('');
    const amount = parseFloat(withdrawalForm.amount);
    const available = Number(commissionSummary.available_balance || 0);
    if (!withdrawalForm.account_number || !withdrawalForm.ifsc_code || !amount) {
      setWithdrawalMessage('Account number, IFSC code and amount are required');
      return;
    }
    if (amount > available) {
      setWithdrawalMessage(`Amount cannot exceed available commission (₹${available.toFixed(2)})`);
      return;
    }

    setWithdrawalLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/commissions/withdrawals`, {
        method: 'POST',
        headers: commissionHeaders({
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify(withdrawalForm)
      });
      const data = await response.json();
      if (!response.ok) {
        setWithdrawalMessage(data.message || 'Withdrawal failed');
        return;
      }
      setWithdrawalMessage(`Withdrawal of ₹${Number(data.amount).toFixed(2)} submitted successfully`);
      setWithdrawalForm({
        account_holder_name: '',
        account_number: '',
        ifsc_code: '',
        bank_name: '',
        amount: '',
        notes: ''
      });
      await loadCommissionSummary();
      await loadCommissionTransactions();
    } catch (error) {
      console.error('Error submitting withdrawal:', error);
      setWithdrawalMessage('Network error while submitting withdrawal');
    } finally {
      setWithdrawalLoading(false);
    }
  };

  const loadCommissionReports = async (groupBy = commissionFilters.group_by, filtersOverride = null) => {
    try {
      const token = localStorage.getItem('authToken');
      const filters = filtersOverride || commissionFilters;
      const params = new URLSearchParams();
      params.append('group_by', groupBy);
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      if (filters.standard) params.append('standard', filters.standard);
      if (filters.division) params.append('division', filters.division);

      const response = await fetch(`${API_BASE_URL}/school/commissions/reports?${params}`, {
        headers: commissionHeaders({ Authorization: `Bearer ${token}` })
      });
      if (response.status === 403) {
        clearCommissionUnlock();
        setActiveMenu('dashboard');
        setCommissionOtpOpen(true);
        return;
      }
      if (response.ok) {
        const data = await response.json();
        setCommissionReports(data.reports || []);
      }
    } catch (error) {
      console.error('Error loading commission reports:', error);
    }
  };

  const getDefaultCommissionFilters = () => ({
    start_date: '',
    end_date: '',
    standard: '',
    division: '',
    group_by: 'detail'
  });

  const resetCommissionFilters = async () => {
    const cleared = getDefaultCommissionFilters();
    setCommissionFilters(cleared);
    await loadCommissionSummary(cleared);
    if (activeSubmenu === 'commission-withdrawal') {
      await loadCommissionTransactions(cleared);
      return;
    }
    const groupMap = {
      'commission-summary': 'detail',
      'commission-date-report': 'date',
      'commission-division-report': 'division',
      'commission-detail-report': 'detail',
      'commission-event-report': 'event'
    };
    await loadCommissionReports(groupMap[activeSubmenu] || 'detail', cleared);
  };

  const loadDeviceSalesReport = async (filtersOverride = null) => {
    try {
      const token = localStorage.getItem('authToken');
      const filters = filtersOverride || deviceSalesFilters;
      const params = new URLSearchParams();
      if (filters.standard) params.append('standard', filters.standard);
      if (filters.division) params.append('division', filters.division);
      if (filters.assignment_status) params.append('assignment_status', filters.assignment_status);

      const response = await fetch(`${API_BASE_URL}/school/devices/sales-report?${params}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setDeviceSalesReports(data.reports || []);
        setDeviceSalesSummary(data.summary || {
          total_devices: 0,
          sold_to_student: 0,
          school_inventory: 0
        });
      }
    } catch (error) {
      console.error('Error loading device sales report:', error);
    }
  };

  const resetDeviceSalesFilters = async () => {
    const cleared = { standard: '', division: '', assignment_status: '' };
    setDeviceSalesFilters(cleared);
    await loadDeviceSalesReport(cleared);
  };

  const handleCollectPayment = async () => {
    if (!paymentForm.studentId || !paymentForm.amount || !paymentForm.planId) {
      alert('Please fill all required fields');
      return;
    }
    
    // First confirmation
    const student = students.find(s => s.id == paymentForm.studentId);
    const plan = subscriptionPlans.find(p => p.id == paymentForm.planId);
    
    const confirmMessage = `Confirm Payment Collection:\n\nStudent: ${student?.first_name} ${student?.last_name}\nPlan: ${plan?.name}\nAmount: ₹${paymentForm.amount}\nMethod: ${paymentForm.paymentMethod}\n\nProceed with payment?`;
    
    if (!window.confirm(confirmMessage)) {
      return;
    }
    
    // Second confirmation
    if (!window.confirm('Are you sure you want to collect this payment? This action cannot be undone.')) {
      return;
    }
    
    try {
      setLoading(true);
      
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/collect-payment`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          student_id: paymentForm.studentId,
          plan_id: paymentForm.planId,
          amount: paymentForm.totalAmount,
          base_amount: paymentForm.baseAmount,
          tax_amount: paymentForm.taxAmount,
          tax_percentage: TAX_PERCENTAGE,
          payment_method: paymentForm.paymentMethod,
          payment_date: paymentForm.paymentDate
        })
      });
      
      if (response.ok) {
        alert('Payment collected successfully!');
        setPaymentForm({
          studentId: '',
          amount: '',
          paymentMethod: 'cash',
          planId: '',
          paymentDate: new Date().toISOString().split('T')[0],
          baseAmount: '',
          taxAmount: '',
          totalAmount: ''
        });
        // Refresh student list to show updated subscription
        loadStudents();
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message || 'Failed to collect payment'}`);
      }
    } catch (error) {
      console.error('Error collecting payment:', error);
      alert('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleAssignmentFormChange = (field, value) => {
    setAssignmentForm(prev => ({ ...prev, [field]: value }));
  };

  const handleAssignDevice = async () => {
    if (!assignmentForm.deviceId || !assignmentForm.studentId) {
      alert('Please select both device and student');
      return;
    }
    
    try {
      setLoading(true);
      
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/assign-device`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          device_id: assignmentForm.deviceId,
          student_id: assignmentForm.studentId
        })
      });
      
      if (response.ok) {
        // Update local state
        const updatedStudents = students.map(student => 
          student.id === parseInt(assignmentForm.studentId) 
            ? { ...student, device_id: assignmentForm.deviceId }
            : student
        );
        setStudents(updatedStudents);
        
        alert('Device assigned successfully!');
        
        // Reset form
        setAssignmentForm({
          deviceId: '',
          studentId: ''
        });
        
        // Reload data
        loadStudents();
        setActiveSubmenu('all-devices');
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message || 'Failed to assign device'}`);
      }
    } catch (error) {
      console.error('Error assigning device:', error);
      alert('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleDisconnectDevice = async (student) => {
    const studentId = typeof student === 'object' ? student.id : student;
    const studentRecord = typeof student === 'object'
      ? student
      : students.find((s) => s.id === parseInt(studentId, 10));

    if (!studentRecord?.device_id) {
      alert('This student does not have a device assigned');
      return;
    }

    const studentName = `${studentRecord.first_name || ''} ${studentRecord.last_name || ''}`.trim();
    const deviceId = studentRecord.device_id;

    const firstConfirm = window.confirm(
      `Unassign device from student?\n\nStudent: ${studentName}\nClass: ${studentRecord.standard || '-'} / ${studentRecord.division || '-'}\nDevice: ${deviceId}\n\nContinue?`
    );
    if (!firstConfirm) return;

    const secondConfirm = window.confirm(
      `Final confirmation\n\nUnassign device "${deviceId}" from "${studentName}"?\n\nAfter this:\n- Device will be free to assign to another student\n- This student can be assigned a different device\n\nAre you sure?`
    );
    if (!secondConfirm) return;

    try {
      setLoading(true);

      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/disconnect-device`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          student_id: studentId
        })
      });

      if (response.ok) {
        setStudents((prev) => prev.map((s) =>
          s.id === parseInt(studentId, 10)
            ? { ...s, device_id: null, device_status: 'inactive' }
            : s
        ));

        alert(`Device "${deviceId}" unassigned from ${studentName}.\nDevice is now available for assignment.`);
        loadStudents();
        loadDevices();
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message || 'Failed to unassign device'}`);
      }
    } catch (error) {
      console.error('Error unassigning device:', error);
      alert('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const drawerWidth = 280;

  useEffect(() => {
    loadStudents();
    loadMasterData();
    loadDevices();
    loadSubscriptionPlans();
  }, []);

  // Load required data when menu/submenu changes
  useEffect(() => {
    if (activeMenu === 'students') {
      loadStudents();
      loadMasterData();
    }
    if (activeMenu === 'devices') {
      loadDevices();
      loadStudents();
    }
    if (activeMenu === 'subscription') {
      loadStudents();
      loadSubscriptionPlans();
      if (activeSubmenu === 'payment-reports') {
        loadPaymentReports();
      }
      if (activeSubmenu === 'subscription-status') {
        loadStudents(); // Reload to get fresh subscription data
      }
    }
    if (activeMenu === 'commission') {
      loadCommissionSummary();
      if (activeSubmenu === 'commission-withdrawal') {
        loadCommissionTransactions();
      } else {
        const groupMap = {
          'commission-summary': 'detail',
          'commission-date-report': 'date',
          'commission-division-report': 'division',
          'commission-detail-report': 'detail',
          'commission-event-report': 'event'
        };
        loadCommissionReports(groupMap[activeSubmenu] || 'detail');
      }
    }
    if (activeMenu === 'sales') {
      loadDeviceSalesReport();
    }
    if (activeMenu === 'settings') {
      loadMasterData();
    }
    if (activeMenu === 'parents') {
      loadStudents();
      loadParentAccounts();
    }
    if (activeMenu === 'geofencing') {
      loadStudents();
    }
  }, [activeMenu, activeSubmenu]);

  // Reload students when switching to student management
  useEffect(() => {
    if (activeMenu === 'students' && activeSubmenu === 'all-students') {
      loadStudents();
    }
  }, [activeMenu, activeSubmenu]);

  // Reload devices when switching to device management
  useEffect(() => {
    if (activeMenu === 'devices' && activeSubmenu === 'all-devices') {
      loadDevices();
    }
  }, [activeMenu, activeSubmenu]);

  useEffect(() => {
    applyFilters();
  }, [students, filters]);

  const applyFilters = () => {
    let filtered = students.filter(student => {
      const matchesSearch = !filters.search || 
        `${student.first_name} ${student.last_name}`.toLowerCase().includes(filters.search.toLowerCase()) ||
        student.roll_number?.toString().includes(filters.search);
      
      const matchesStandard = !filters.standard || student.standard === filters.standard;
      const matchesDivision = !filters.division || student.division === filters.division;
      const matchesStatus = !filters.status || student.device_status === filters.status;
      
      const matchesBattery = !filters.batteryLevel || 
        (filters.batteryLevel === 'low' && student.battery_level < 30) ||
        (filters.batteryLevel === 'medium' && student.battery_level >= 30 && student.battery_level < 70) ||
        (filters.batteryLevel === 'high' && student.battery_level >= 70);
      
      return matchesSearch && matchesStandard && matchesDivision && matchesStatus && matchesBattery;
    });
    setFilteredStudents(filtered);
  };

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  const clearFilters = () => {
    setFilters({
      search: '',
      standard: '',
      division: '',
      status: '',
      batteryLevel: ''
    });
  };

  const loadMasterData = async () => {
    // Load standards from database
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/standards`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const data = await response.json();
        setStandards(data);
        setClasses(data);
      } else {
        const fallbackStandards = [
          { id: 1, name: '1st' }, { id: 2, name: '2nd' }, { id: 3, name: '3rd' },
          { id: 4, name: '4th' }, { id: 5, name: '5th' }, { id: 6, name: '6th' },
          { id: 7, name: '7th' }, { id: 8, name: '8th' }, { id: 9, name: '9th' },
          { id: 10, name: '10th' }, { id: 11, name: '11th' }, { id: 12, name: '12th' }
        ];
        setStandards(fallbackStandards);
        setClasses(fallbackStandards);
      }
    } catch (error) {
      console.error('Error loading standards:', error);
    }
    
    // Load divisions from database
    try {
      const token = localStorage.getItem('authToken');
      const divResponse = await fetch(`${API_BASE_URL}/school/divisions`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (divResponse.ok) {
        const divData = await divResponse.json();
        setDivisions(divData);
      } else {
        setDivisions([
          { id: 1, name: 'A' }, { id: 2, name: 'B' }, { id: 3, name: 'C' },
          { id: 4, name: 'D' }, { id: 5, name: 'E' }
        ]);
      }
    } catch (error) {
      console.error('Error loading divisions:', error);
    }
    
    // Load teachers from database
    try {
      const token = localStorage.getItem('authToken');
      const teacherResponse = await fetch(`${API_BASE_URL}/school/teachers`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (teacherResponse.ok) {
        const teacherData = await teacherResponse.json();
        setTeachers(teacherData);
      } else {
        setTeachers([
          { id: 1, name: 'John Smith' },
          { id: 2, name: 'Sarah Johnson' },
          { id: 3, name: 'Mike Wilson' }
        ]);
      }
    } catch (error) {
      console.error('Error loading teachers:', error);
    }
    
    setDevicePackages([
      { id: 1, name: 'Basic Package', price: 500 },
      { id: 2, name: 'Premium Package', price: 800 },
      { id: 3, name: 'Enterprise Package', price: 1200 }
    ]);
  };

  const loadStudents = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/students`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setStudents(data);
      } else {
        console.error('Failed to load students:', response.status);
        setStudents([]);
      }
    } catch (error) {
      console.error('Error loading students:', error);
      setStudents([]);
    } finally {
      setLoading(false);
    }
  };

  const loadDevices = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/devices`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setDevices(data);
      } else {
        console.error('Failed to load devices:', response.status);
        setDevices([]);
      }
    } catch (error) {
      console.error('Error loading devices:', error);
      setDevices([]);
    }
  };

  const handleUpdateDevice = (formData) => {
    if (editingDevice) {
      // Update existing device
      setDevices(prev => prev.map(device => 
        device.id === editingDevice.id 
          ? { ...device, ...formData }
          : device
      ));
      alert('Device updated successfully!');
    }
    setActiveSubmenu('all-devices');
    setEditingDevice(null);
  };



  const menuItems = [
    { id: 'dashboard', icon: <DashboardIcon />, label: 'Dashboard' },
    { 
      id: 'students', 
      icon: <GroupIcon />, 
      label: 'Students',
      submenu: [
        { id: 'all-students', label: 'All Students' },
        { id: 'add-student', label: 'Add Student' },
        { id: 'import-students', label: 'Import Students' }
      ]
    },
    { 
      id: 'devices', 
      icon: <DevicesIcon />, 
      label: 'Device Management',
      submenu: [
        { id: 'all-devices', label: 'Assigned Devices' },
        { id: 'device-assignment', label: 'Assign to Student' },
        { id: 'device-unassignment', label: 'Unassign Device' }
      ]
    },
    {
      id: 'subscription',
      icon: <Icon>payment</Icon>,
      label: 'Subscription Management',
      submenu: [
        { id: 'payment-collection', label: 'Payment Collection' },
        { id: 'subscription-status', label: 'Subscription Status' },
        { id: 'payment-reports', label: 'Payment Reports' },
        { id: 'renewal-reminders', label: 'Renewal Reminders' }
      ]
    },
    {
      id: 'parents',
      icon: <GroupIcon />,
      label: 'Parent Management',
      submenu: [
        { id: 'parent-accounts', label: 'Parent Accounts' },
        { id: 'create-parent-login', label: 'Create Parent Login' },
        { id: 'assign-students-to-parent', label: 'Assign Students to Parent' },
        { id: 'reset-parent-password', label: 'Reset Parent Password' },
        { id: 'parent-notifications', label: 'Send Notifications' }
      ]
    },
    {
      id: 'commission',
      icon: <Icon>account_balance_wallet</Icon>,
      label: 'Commission',
      submenu: [
        { id: 'commission-summary', label: 'Commission Summary' },
        { id: 'commission-withdrawal', label: 'Withdrawal' },
        { id: 'commission-date-report', label: 'Date-wise Report' },
        { id: 'commission-division-report', label: 'Division-wise Report' },
        { id: 'commission-event-report', label: 'Payment Source Report' },
        { id: 'commission-detail-report', label: 'Detailed Ledger' }
      ]
    },
    {
      id: 'sales',
      icon: <ReportsIcon />,
      label: 'Sales Reports',
      submenu: [
        { id: 'device-sales-report', label: 'Device Sales Report' }
      ]
    },
    {
      id: 'settings',
      icon: <SettingsIcon />,
      label: 'Settings',
      submenu: [
        { id: 'school-profile', label: 'School Profile' },
        { id: 'add-standard', label: 'Add Standard' },
        { id: 'add-division', label: 'Add Division' },
        { id: 'class-teachers', label: 'Class Teachers' }
      ]
    },
  ];

  const StatCard = ({ title, value, icon, color, percentage, trend }) => (
    <Card sx={{ height: '100%' }}>
      <Box sx={{ p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography variant="h6" color="textSecondary" gutterBottom>
              {title}
            </Typography>
            <Typography variant="h4" component="div" fontWeight="bold">
              {value}
            </Typography>
          </Box>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: 2,
              background: `linear-gradient(135deg, ${color}40, ${color})`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              mt: -1
            }}
          >
            {icon}
          </Box>
        </Box>
        <Divider sx={{ my: 1 }} />
        <Box display="flex" alignItems="center">
          <Typography
            variant="body2"
            color={trend === 'up' ? 'success.main' : 'error.main'}
            fontWeight="bold"
          >
            {percentage}
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ ml: 1 }}>
            than last week
          </Typography>
        </Box>
      </Box>
    </Card>
  );

  const renderDashboard = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        School Dashboard
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        Monitor student safety and track device performance in real-time.
      </Typography>

      {/* Stats Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Students"
            value={students.length}
            icon={<GroupIcon fontSize="large" />}
            color="#1976d2"
            percentage="+12%"
            trend="up"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Active Trackers"
            value={students.filter(s => s.device_status === 'active').length}
            icon={<LocationIcon fontSize="large" />}
            color="#2e7d32"
            percentage="+5%"
            trend="up"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Low Battery"
            value={students.filter(s => s.battery_level < 30).length}
            icon={<Icon fontSize="large">battery_alert</Icon>}
            color="#ed6c02"
            percentage="-2%"
            trend="down"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Safety Score"
            value="98%"
            icon={<Icon fontSize="large">shield</Icon>}
            color="#9c27b0"
            percentage="+1%"
            trend="up"
          />
        </Grid>
      </Grid>

      {/* Recent Activity */}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card>
            <Box sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Recent Activity
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Latest student tracking updates and system notifications.
              </Typography>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );

  const renderStudents = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" fontWeight="bold">
          Student Management
        </Typography>
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={loadStudents}
        >
          Refresh
        </Button>
      </Box>
      
      {/* Filters */}
      <Card sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Filters
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size="small"
              label="Search"
              placeholder="Name or Roll Number"
              value={filters.search}
              onChange={(e) => handleFilterChange('search', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Standard</InputLabel>
              <Select
                value={filters.standard || ''}
                label="Standard"
                onChange={(e) => handleFilterChange('standard', e.target.value)}
              >
                <MenuItem value="">All</MenuItem>
                {standards.map(std => (
                  <MenuItem key={std.id} value={std.name}>{std.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Division</InputLabel>
              <Select
                value={filters.division || ''}
                label="Division"
                onChange={(e) => handleFilterChange('division', e.target.value)}
              >
                <MenuItem value="">All</MenuItem>
                {divisions.map(div => (
                  <MenuItem key={div.id} value={div.name}>{div.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Status</InputLabel>
              <Select
                value={filters.status || ''}
                label="Status"
                onChange={(e) => handleFilterChange('status', e.target.value)}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Battery</InputLabel>
              <Select
                value={filters.batteryLevel || ''}
                label="Battery"
                onChange={(e) => handleFilterChange('batteryLevel', e.target.value)}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="low">Low (&lt;30%)</MenuItem>
                <MenuItem value="medium">Medium (30-70%)</MenuItem>
                <MenuItem value="high">High (&gt;70%)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={1}>
            <Button
              variant="outlined"
              size="small"
              onClick={clearFilters}
              sx={{ minWidth: 'auto', px: 1 }}
            >
              Clear
            </Button>
          </Grid>
        </Grid>
        <Box mt={2}>
          <Typography variant="body2" color="textSecondary">
            Showing {filteredStudents.length} of {students.length} students
          </Typography>
        </Box>
      </Card>
      
      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Student</TableCell>
                <TableCell>Class</TableCell>
                <TableCell>Device</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center">Subscription</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredStudents.map((student) => (
                <TableRow key={student.id}>
                  <TableCell>
                    <Box display="flex" alignItems="center">
                      <Avatar sx={{ mr: 2, bgcolor: 'primary.main' }}>
                        {student.first_name?.charAt(0)}{student.last_name?.charAt(0)}
                      </Avatar>
                      <Box>
                        <Typography variant="body2" fontWeight="bold">
                          {student.first_name} {student.last_name}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          Roll: {student.roll_number}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {student.standard} - {student.division}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" fontWeight="bold">
                      {student.device_id || 'No Device'}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {student.device_type || (student.device_id ? 'GPS Tracker' : 'Not Assigned')}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Chip
                      label={student.device_status || 'inactive'}
                      color={student.device_status === 'active' ? 'success' : 'default'}
                      size="small"
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Box>
                      <Chip
                        label={student.subscription_display_status || 'No Plan'}
                        color={
                          student.subscription_display_status === 'Active' ? 'success' :
                          student.subscription_display_status === 'Expiring Soon' ? 'warning' : 'error'
                        }
                        size="small"
                      />
                      <Typography variant="caption" display="block">
                        {student.days_remaining || 0} days
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      size="small"
                      color="secondary"
                      onClick={() => {
                        // Set student data for editing
                        setStudentForm({
                          firstName: student.first_name,
                          lastName: student.last_name,
                          academicYear: '2024-25',
                          classId: classes.find(c => c.name === student.standard)?.id || '',
                          divisionId: divisions.find(d => d.name === student.division)?.id || '',
                          rollNumber: student.roll_number,
                          teacherId: '',
                          deviceId: student.device_id || '',
                          devicePackageId: '',
                          parentEmail: '',
                          parentName: ''
                        });
                        setEditingStudentId(student.id);
                        setActiveSubmenu('edit-student');
                      }}
                      sx={{ mr: 1 }}
                    >
                      <EditIcon />
                    </IconButton>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => {
                        setPaymentForm(prev => ({...prev, studentId: student.id}));
                        setActiveMenu('subscription');
                        setActiveSubmenu('payment-collection');
                      }}
                    >
                      Renew
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );

  const handleStudentFormChange = (field, value) => {
    setStudentForm(prev => ({ ...prev, [field]: value }));
  };

  const handleParentFormChange = (field, value) => {
    setParentForm(prev => ({ ...prev, [field]: value }));
  };

  const checkParentExists = async (email) => {
    if (!email) return;
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/check-parent?email=${email}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const data = await response.json();
        if (data.exists) {
          setParentForm(prev => ({
            ...prev,
            firstName: data.parent.first_name,
            lastName: data.parent.last_name,
            phone: data.parent.phone,
            address: data.parent.address || ''
          }));
          setParentExists(true);
        } else {
          setParentExists(false);
        }
      }
    } catch (error) {
      console.error('Error checking parent:', error);
    }
  };

  const handleAddParent = () => {
    setParentDialog(true);
    setParentForm({
      email: '',
      firstName: '',
      lastName: '',
      phone: '',
      address: '',
      password: ''
    });
    setParentExists(false);
  };

  const loadParentAccounts = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/parent-accounts`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const data = await response.json();
        setParentAccounts(data);
      } else {
        console.error('Failed to load parent accounts:', response.status);
      }
    } catch (error) {
      console.error('Error loading parent accounts:', error);
    }
  };

  const handleResetPassword = async () => {
    if (!resetPasswordForm.parentId || !resetPasswordForm.newPassword) {
      alert('Please select a parent and enter a new password');
      return;
    }
    
    if (resetPasswordForm.newPassword.length < 6) {
      alert('Password must be at least 6 characters long');
      return;
    }
    
    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/reset-parent-password`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
          parent_id: resetPasswordForm.parentId,
          new_password: resetPasswordForm.newPassword
        })
      });
      
      if (response.ok) {
        const result = await response.json();
        alert(`Password reset successfully for ${resetPasswordForm.parentName}!\nNew password: ${result.new_password}`);
        setResetPasswordDialog(false);
        setResetPasswordForm({ parentId: '', parentName: '', newPassword: '' });
      } else {
        const errorText = await response.text();
        alert('Failed to reset password: ' + errorText);
      }
    } catch (error) {
      console.error('Error resetting password:', error);
      alert('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleSendNotification = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const { title, message, type, selectedParents } = notificationForm;
      if (!title || !message) {
        alert('Title and message are required.');
        return;
      }
      const parentIds = (selectedParents && selectedParents.length > 0)
        ? selectedParents
        : parentAccounts.map(p => p.id); // fallback to all parents

      if (!parentIds.length) {
        alert('No parents available to notify.');
        return;
      }

      const requests = parentIds.map(parentId =>
        fetch(`${API_BASE_URL}/admin/send-push`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            user_id: parentId,
            title: title,
            body: message,
            data: { type: type || 'info' }
          })
        })
      );

      const responses = await Promise.all(requests);
      const allOk = responses.every(res => res.ok);

      if (allOk) {
        alert('Notification sent successfully!');
        setNotificationDialog(false);
        setNotificationForm({ title: '', message: '', type: 'info', selectedParents: [] });
      } else {
        alert('Some notifications may have failed. Please check logs.');
      }
    } catch (error) {
      console.error('Error sending notification:', error);
      alert('Failed to send notification. Please try again.');
    }
  };

  const handleEditParent = async (parent) => {
    setEditParentForm({
      id: parent.id,
      firstName: parent.first_name,
      lastName: parent.last_name,
      email: parent.email,
      phone: parent.phone || '',
      address: '',
      status: parent.status,
      assignedStudents: []
    });
    
    // Load assigned students
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/parent-students/${parent.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const assignedStudents = await response.json();
        setEditParentForm(prev => ({...prev, assignedStudents}));
      }
    } catch (error) {
      console.error('Error loading assigned students:', error);
    }
    
    setEditParentDialog(true);
  };

  const handleUpdateParent = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/update-parent/${editParentForm.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          first_name: editParentForm.firstName,
          last_name: editParentForm.lastName,
          email: editParentForm.email,
          phone: editParentForm.phone,
          status: editParentForm.status
        })
      });
      
      if (response.ok) {
        alert('Parent updated successfully!');
        setEditParentDialog(false);
        loadParentAccounts();
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message || 'Failed to update parent'}`);
      }
    } catch (error) {
      console.error('Error updating parent:', error);
      alert('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteParent = async (parentId, parentName) => {
    if (!window.confirm(`Are you sure you want to delete parent account for ${parentName}? This action cannot be undone.`)) {
      return;
    }
    
    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/delete-parent/${parentId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        alert('Parent account deleted successfully!');
        loadParentAccounts();
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message || 'Failed to delete parent account'}`);
      }
    } catch (error) {
      console.error('Error deleting parent:', error);
      alert('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateParent = async () => {
    if (createParentForm.password.length < 6) {
      alert('Password must be at least 6 characters long');
      return;
    }
    
    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/create-parent-with-students`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          first_name: createParentForm.firstName,
          last_name: createParentForm.lastName,
          email: createParentForm.email,
          phone: createParentForm.phone,
          address: createParentForm.address,
          password: createParentForm.password,
          selected_students: createParentForm.selectedStudents
        })
      });
      
      if (response.ok) {
        alert('Parent account created successfully!');
        setCreateParentForm({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          address: '',
          password: '',
          selectedStudents: []
        });
        setStudentFilters({ search: '', standard: '', division: '' });
        loadParentAccounts();
        setActiveSubmenu('parent-accounts');
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message || 'Failed to create parent account'}`);
      }
    } catch (error) {
      console.error('Error creating parent:', error);
      alert('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleAssignStudentsToParent = async () => {
    if (!assignStudentsForm.parentId || assignStudentsForm.selectedStudents.length === 0) {
      alert('Please select a parent and at least one student');
      return;
    }
    
    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/assign-students-to-parent`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          parent_id: assignStudentsForm.parentId,
          student_ids: assignStudentsForm.selectedStudents
        })
      });
      
      if (response.ok) {
        alert('Students assigned to parent successfully!');
        setAssignStudentsForm({
          parentId: '',
          selectedStudents: [],
          searchTerm: '',
          parentSearchTerm: ''
        });
        loadStudents();
        setActiveSubmenu('parent-accounts');
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message || 'Failed to assign students'}`);
      }
    } catch (error) {
      console.error('Error assigning students:', error);
      alert('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const resetStudentForm = () => {
    setStudentForm({ ...DEFAULT_STUDENT_FORM });
  };

  const handleAddStudent = async () => {
    // Validate required fields
    if (!studentForm.firstName || !studentForm.lastName || !studentForm.classId || !studentForm.divisionId) {
      alert('Please fill in all required fields');
      return;
    }
    
    try {
      setLoading(true);
      
      const studentData = {
        first_name: studentForm.firstName,
        last_name: studentForm.lastName,
        standard: classes.find(c => c.id == studentForm.classId)?.name,
        division: divisions.find(d => d.id == studentForm.divisionId)?.name,
        roll_number: studentForm.rollNumber,
        device_id: studentForm.deviceId
      };

      // Include parent data if provided
      if (studentForm.parentEmail && parentForm.email) {
        studentData.parent_data = {
          email: parentForm.email,
          first_name: parentForm.firstName,
          last_name: parentForm.lastName,
          phone: parentForm.phone,
          address: parentForm.address,
          password: parentForm.password,
          exists: parentExists
        };
      }
      
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/students`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(studentData)
      });
      
      if (response.ok) {
        alert('Student and parent added successfully!');
        
        // Reset forms
        resetStudentForm();
        setParentForm({
          email: '',
          firstName: '',
          lastName: '',
          phone: '',
          address: '',
          password: ''
        });
        
        // Reload students list
        loadStudents();
        setActiveSubmenu('all-students');
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message || 'Failed to add student'}`);
      }
    } catch (error) {
      console.error('Error adding student:', error);
      alert('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateStudent = async () => {
    if (!editingStudentId) {
      alert('Please select a student to update');
      return;
    }

    if (!studentForm.firstName || !studentForm.lastName || !studentForm.classId || !studentForm.divisionId) {
      alert('Please fill in all required fields');
      return;
    }

    try {
      setLoading(true);

      const studentData = {
        first_name: studentForm.firstName,
        last_name: studentForm.lastName,
        standard: classes.find(c => c.id == studentForm.classId)?.name,
        division: divisions.find(d => d.id == studentForm.divisionId)?.name,
        roll_number: studentForm.rollNumber,
        device_id: studentForm.deviceId
      };

      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/students/${editingStudentId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(studentData)
      });

      if (response.ok) {
        alert('Student updated successfully!');
        resetStudentForm();
        setEditingStudentId(null);
        setActiveSubmenu('all-students');
        loadStudents();
      } else {
        const errorData = await response.json().catch(() => ({}));
        alert(`Error: ${errorData.message || 'Failed to update student'}`);
      }
    } catch (error) {
      console.error('Error updating student:', error);
      alert('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const renderAddStudent = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Add New Student
      </Typography>
      <Card sx={{ p: 3, maxWidth: 800 }}>
        <Typography variant="h6" gutterBottom>
          Student Information
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField 
              fullWidth 
              label="First Name" 
              variant="outlined" 
              required 
              value={studentForm.firstName}
              onChange={(e) => handleStudentFormChange('firstName', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField 
              fullWidth 
              label="Last Name" 
              variant="outlined" 
              required 
              value={studentForm.lastName}
              onChange={(e) => handleStudentFormChange('lastName', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Academic Year</InputLabel>
              <Select 
                label="Academic Year"
                value={studentForm.academicYear}
                onChange={(e) => handleStudentFormChange('academicYear', e.target.value)}
              >
                <MenuItem value="2024-25">2024-25</MenuItem>
                <MenuItem value="2023-24">2023-24</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Class</InputLabel>
              <Select 
                label="Class"
                value={studentForm.classId}
                onChange={(e) => handleStudentFormChange('classId', e.target.value)}
              >
                {classes.map(cls => (
                  <MenuItem key={cls.id} value={cls.id}>{cls.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Division</InputLabel>
              <Select 
                label="Division"
                value={studentForm.divisionId}
                onChange={(e) => handleStudentFormChange('divisionId', e.target.value)}
              >
                {divisions.map(div => (
                  <MenuItem key={div.id} value={div.id}>{div.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField 
              fullWidth 
              label="Roll Number" 
              variant="outlined" 
              type="number" 
              value={studentForm.rollNumber}
              onChange={(e) => handleStudentFormChange('rollNumber', e.target.value)}
            />
          </Grid>
          {/* Parent Information Section */}
          <Grid item xs={12}>
            <Box sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Parent Information
              </Typography>
              {studentForm.parentEmail && studentForm.parentName ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, bgcolor: 'success.light', borderRadius: 1, mb: 2 }}>
                  <Typography variant="body2" color="success.dark">
                    ✓ Parent Linked: {studentForm.parentName} ({studentForm.parentEmail})
                  </Typography>
                  <Button 
                    size="small"
                    variant="outlined" 
                    color="primary"
                    onClick={handleAddParent}
                  >
                    Change Parent
                  </Button>
                </Box>
              ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Typography variant="body2" color="textSecondary">
                    Want to create parent login access?
                  </Typography>
                  <Button 
                    variant="outlined" 
                    color="primary"
                    onClick={handleAddParent}
                  >
                    Add Parent
                  </Button>
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ mt: 2 }}>
              <Button 
                variant="contained" 
                color="primary" 
                sx={{ mr: 2 }} 
                onClick={handleAddStudent}
                disabled={loading}
              >
                {loading ? 'Adding...' : 'Add Student'}
              </Button>
              <Button variant="outlined" onClick={() => setActiveSubmenu('all-students')}>
                Cancel
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );

  const renderEditStudent = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Edit Student
      </Typography>
      <Card sx={{ p: 3, maxWidth: 800 }}>
        <Typography variant="h6" gutterBottom>
          Student Information
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField 
              fullWidth 
              label="First Name" 
              variant="outlined" 
              required 
              value={studentForm.firstName}
              onChange={(e) => handleStudentFormChange('firstName', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField 
              fullWidth 
              label="Last Name" 
              variant="outlined" 
              required 
              value={studentForm.lastName}
              onChange={(e) => handleStudentFormChange('lastName', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Class</InputLabel>
              <Select 
                label="Class"
                value={studentForm.classId}
                onChange={(e) => handleStudentFormChange('classId', e.target.value)}
              >
                {classes.map(cls => (
                  <MenuItem key={cls.id} value={cls.id}>{cls.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Division</InputLabel>
              <Select 
                label="Division"
                value={studentForm.divisionId}
                onChange={(e) => handleStudentFormChange('divisionId', e.target.value)}
              >
                {divisions.map(div => (
                  <MenuItem key={div.id} value={div.id}>{div.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField 
              fullWidth 
              label="Roll Number" 
              variant="outlined" 
              type="number" 
              value={studentForm.rollNumber}
              onChange={(e) => handleStudentFormChange('rollNumber', e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ mt: 2 }}>
              <Button 
                variant="contained" 
                color="primary" 
                sx={{ mr: 2 }} 
                disabled={loading || !editingStudentId}
                onClick={handleUpdateStudent}
              >
                {loading ? 'Updating...' : 'Update Student'}
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  resetStudentForm();
                  setEditingStudentId(null);
                  setActiveSubmenu('all-students');
                }}
              >
                Cancel
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );

  const renderImportStudents = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Import Students
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Upload Excel File
            </Typography>
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <CloudUploadIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
              <Typography variant="body1" gutterBottom>
                Drag and drop your Excel file here or click to browse
              </Typography>
              <Button variant="contained" component="label" sx={{ mt: 2 }}>
                Choose File
                <input
                  type="file"
                  hidden
                  accept=".xlsx,.xls,.csv"
                  onChange={handleStudentImportFileChange}
                />
              </Button>
              {importFile && (
                <Typography variant="body2" sx={{ mt: 2 }}>
                  Selected: {importFile.name}
                </Typography>
              )}
            </Box>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
              Supported formats: .xlsx, .xls, .csv (Max size: 5MB)
            </Typography>
            <Box sx={{ mt: 2, display: 'flex', gap: 2, justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<UploadIcon />}
                onClick={handleImportStudentsUpload}
                disabled={importingStudents}
              >
                {importingStudents ? 'Importing...' : 'Upload & Import'}
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  setImportFile(null);
                  setImportSummary(null);
                  setImportErrors([]);
                }}
              >
                Reset
              </Button>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Excel Format Requirements
            </Typography>
            <Typography variant="body2" paragraph>
              Your Excel file should contain the following columns:
            </Typography>
            <Box component="ul" sx={{ pl: 2 }}>
              <li>First Name</li>
              <li>Last Name</li>
              <li>Academic Year</li>
              <li>Class</li>
              <li>Division</li>
              <li>Roll Number</li>
              <li>Parent Mobile 1</li>
              <li>Parent Mobile 2</li>
              <li>Parent Name</li>
            </Box>
            <Button
              variant="outlined"
              sx={{ mt: 2 }}
              component="a"
              href="/templates/student-import-sample.csv"
              download
            >
              Download Sample Template
            </Button>
          </Card>
        </Grid>
        {(importSummary || importErrors.length > 0) && (
          <Grid item xs={12}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Import Summary
              </Typography>
              {importSummary ? (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="body2" color="textSecondary">Total Rows</Typography>
                    <Typography variant="h6">{importSummary.total_rows ?? '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="body2" color="textSecondary">Students Created</Typography>
                    <Typography variant="h6">{importSummary.students_created ?? '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="body2" color="textSecondary">Parents Created</Typography>
                    <Typography variant="h6">{importSummary.parents_created ?? '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="body2" color="textSecondary">Skipped Rows</Typography>
                    <Typography variant="h6">{importSummary.skipped ?? '-'}</Typography>
                  </Grid>
                </Grid>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  Import finished with errors.
                </Typography>
              )}
              {importErrors.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle1" gutterBottom>
                    Errors
                  </Typography>
                  <Box component="ul" sx={{ pl: 3 }}>
                    {importErrors.map((error, index) => (
                      <li key={`${error.row}-${index}`}>
                        Row {error.row}: {error.message}
                      </li>
                    ))}
                  </Box>
                </Box>
              )}
            </Card>
          </Grid>
        )}
      </Grid>
    </Box>
  );

  const renderAddTeacher = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Add New Teacher
      </Typography>
      <Card sx={{ p: 3, maxWidth: 600 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Teacher Name" variant="outlined" required />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Employee ID" variant="outlined" required />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Email" variant="outlined" type="email" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Phone" variant="outlined" />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth label="Subject" variant="outlined" />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ mt: 2 }}>
              <Button variant="contained" color="primary" sx={{ mr: 2 }}>
                Add Teacher
              </Button>
              <Button variant="outlined" onClick={() => setActiveSubmenu('all-students')}>
                Cancel
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );

  // Settings Forms
  const renderAddStandard = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Add New Standard
      </Typography>
      <Card sx={{ p: 3, maxWidth: 600 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Standard Name" variant="outlined" required placeholder="e.g., 1st, 2nd, 10th" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Standard Code" variant="outlined" placeholder="e.g., STD001" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Display Order" variant="outlined" type="number" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select label="Status" defaultValue="active">
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth label="Description" variant="outlined" multiline rows={3} />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ mt: 2 }}>
              <Button variant="contained" color="primary" sx={{ mr: 2 }}>
                Add Standard
              </Button>
              <Button variant="outlined" onClick={() => setActiveSubmenu('add-standard')}>
                Cancel
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );

  const renderSettingsAddDivision = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Add New Division
      </Typography>
      <Card sx={{ p: 3, maxWidth: 600 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth required>
              <InputLabel>Select Standard</InputLabel>
              <Select label="Select Standard">
                {classes.map(cls => (
                  <MenuItem key={cls.id} value={cls.id}>{cls.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Division Name" variant="outlined" required placeholder="e.g., A, B, C" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Max Students" variant="outlined" type="number" defaultValue={40} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Room Number" variant="outlined" />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select label="Status" defaultValue="active">
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ mt: 2 }}>
              <Button variant="contained" color="primary" sx={{ mr: 2 }}>
                Add Division
              </Button>
              <Button variant="outlined" onClick={() => setActiveSubmenu('add-division')}>
                Cancel
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );

  const createClassTeacher = async () => {
    setTeacherSaving(true);
    setTeacherMessage('');
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/school/teachers`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(teacherForm)
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        setTeacherMessage(data.message || 'Failed to create teacher');
        return;
      }
      setTeacherMessage('Class teacher created. They can login at /teacher');
      setTeacherForm({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        standard: '',
        division: ''
      });
      const listRes = await fetch(`${API_BASE_URL}/school/teachers`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (listRes.ok) {
        const list = await listRes.json();
        setTeachers(Array.isArray(list) ? list : []);
      }
    } catch (e) {
      setTeacherMessage('Network error while creating teacher');
    } finally {
      setTeacherSaving(false);
    }
  };

  const requestCommissionAccess = (nav) => {
    if (getCommissionUnlockToken()) {
      if (nav?.menu) setActiveMenu(nav.menu);
      if (nav?.submenu) setActiveSubmenu(nav.submenu);
      return true;
    }
    setPendingCommissionNav(nav || { menu: 'commission', submenu: 'commission-summary' });
    setCommissionOtp('');
    setCommissionOtpError('');
    setCommissionOtpOpen(true);
    return false;
  };

  const submitCommissionOtp = async () => {
    try {
      setCommissionOtpError('');
      await verifyCommissionOtp({
        apiBaseUrl: API_BASE_URL,
        role: 'school',
        otp: commissionOtp
      });
      setCommissionOtpOpen(false);
      const nav = pendingCommissionNav || { menu: 'commission', submenu: 'commission-summary' };
      setActiveMenu(nav.menu);
      setActiveSubmenu(nav.submenu);
      setExpandedMenus({ commission: true });
      setPendingCommissionNav(null);
    } catch (e) {
      setCommissionOtpError(e.message || 'Invalid OTP');
      clearCommissionUnlock();
      setActiveMenu('dashboard');
    }
  };

  const renderAssignTeacher = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Class Teachers
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Create class teacher logins for `/teacher`. Standard and division on this form are optional notes only — teachers can select any class in the portal to view students and assign devices.
      </Typography>
      <Card sx={{ p: 3, maxWidth: 720, mb: 3 }}>
        <Typography variant="h6" gutterBottom>Add class teacher</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="First name"
              value={teacherForm.first_name}
              onChange={(e) => setTeacherForm((p) => ({ ...p, first_name: e.target.value }))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Last name"
              value={teacherForm.last_name}
              onChange={(e) => setTeacherForm((p) => ({ ...p, last_name: e.target.value }))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Email (login)"
              value={teacherForm.email}
              onChange={(e) => setTeacherForm((p) => ({ ...p, email: e.target.value }))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="password"
              label="Password"
              value={teacherForm.password}
              onChange={(e) => setTeacherForm((p) => ({ ...p, password: e.target.value }))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Standard (optional)"
              value={teacherForm.standard}
              onChange={(e) => setTeacherForm((p) => ({ ...p, standard: e.target.value }))}
              placeholder="e.g. 5th"
              helperText="Optional note only — not used to restrict portal access"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Division (optional)"
              value={teacherForm.division}
              onChange={(e) => setTeacherForm((p) => ({ ...p, division: e.target.value }))}
              placeholder="e.g. A"
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" onClick={createClassTeacher} disabled={teacherSaving}>
              {teacherSaving ? 'Saving...' : 'Create Class Teacher'}
            </Button>
            {teacherMessage && (
              <Typography sx={{ mt: 1 }} color={teacherMessage.includes('fail') || teacherMessage.includes('required') || teacherMessage.includes('Error') || teacherMessage.includes('already') ? 'error' : 'success.main'}>
                {teacherMessage}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Card>
      <Card sx={{ p: 2 }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Class</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {teachers.map((t) => (
                <TableRow key={t.id}>
                  <TableCell>{t.first_name} {t.last_name}</TableCell>
                  <TableCell>{t.email}</TableCell>
                  <TableCell>{t.standard || '-'} / {t.division || '-'}</TableCell>
                  <TableCell>{t.status || 'active'}</TableCell>
                </TableRow>
              ))}
              {!teachers.length && (
                <TableRow>
                  <TableCell colSpan={4}>No class teachers yet</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );

  const renderSchoolProfile = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        School Profile
      </Typography>
      <Card sx={{ p: 3, maxWidth: 800 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="School Name" variant="outlined" required />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="School Code" variant="outlined" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Principal Name" variant="outlined" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Contact Number" variant="outlined" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Email" variant="outlined" type="email" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Website" variant="outlined" />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth label="Address" variant="outlined" multiline rows={3} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Established Year" variant="outlined" type="number" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>School Type</InputLabel>
              <Select label="School Type">
                <MenuItem value="primary">Primary School</MenuItem>
                <MenuItem value="secondary">Secondary School</MenuItem>
                <MenuItem value="higher-secondary">Higher Secondary School</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ mt: 2 }}>
              <Button variant="contained" color="primary" sx={{ mr: 2 }}>
                Update Profile
              </Button>
              <Button variant="outlined">
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Card>
      
      <Card sx={{ p: 3, maxWidth: 800, mt: 3 }}>
        <Typography variant="h6" gutterBottom fontWeight="bold">
          Change Password
        </Typography>
        <Button 
          variant="contained" 
          color="secondary"
          onClick={() => setChangePasswordDialog(true)}
        >
          Change Password
        </Button>
      </Card>
    </Box>
  );

  // Device Management Forms
  const renderAllDevices = () => {
    const filteredDevicesForTable = devices.filter(device => {
      const matchesSearch = !deviceFilters.search || 
        (device.deviceId || device.id).toLowerCase().includes(deviceFilters.search.toLowerCase());
      const matchesType = !deviceFilters.type || device.type === deviceFilters.type;
      const matchesStatus = !deviceFilters.status || device.status === deviceFilters.status;
      return matchesSearch && matchesType && matchesStatus;
    });

    return (
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h4" fontWeight="bold">
            Device Management
          </Typography>
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={loadDevices}
            disabled={loading}
          >
            {loading ? 'Refreshing...' : 'Refresh'}
          </Button>
        </Box>
        
        {/* Filters */}
        <Card sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Filters
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                size="small"
                label="Search Device"
                placeholder="Device ID"
                value={deviceFilters.search || ''}
                onChange={(e) => setDeviceFilters(prev => ({...prev, search: e.target.value}))}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Device Type</InputLabel>
                <Select
                  value={deviceFilters.type || ''}
                  label="Device Type"
                  onChange={(e) => setDeviceFilters(prev => ({...prev, type: e.target.value}))}
                >
                  <MenuItem value="">All Types</MenuItem>
                  <MenuItem value="GPS Tracker">GPS Tracker</MenuItem>
                  <MenuItem value="Smart Watch">Smart Watch</MenuItem>
                  <MenuItem value="RFID Card">RFID Card</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select
                  value={deviceFilters.status || ''}
                  label="Status"
                  onChange={(e) => setDeviceFilters(prev => ({...prev, status: e.target.value}))}
                >
                  <MenuItem value="">All Status</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                  <MenuItem value="maintenance">Maintenance</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box mt={2}>
            <Typography variant="body2" color="textSecondary">
              Showing {filteredDevicesForTable.length} of {devices.length} devices
            </Typography>
          </Box>
        </Card>
        
        <Card>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Device ID</TableCell>
                  <TableCell>Device Type</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Battery</TableCell>
                  <TableCell>Last Update</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredDevicesForTable.map((device) => (
                  <TableRow key={device.id}>
                    <TableCell>{device.deviceId}</TableCell>
                    <TableCell>{device.type}</TableCell>
                    <TableCell align="center">
                      <Chip 
                        label={device.status} 
                        color={device.status === 'active' ? 'success' : 'error'} 
                        size="small" 
                      />
                    </TableCell>
                    <TableCell align="center">
                      <LinearProgress variant="determinate" value={device.battery} color="success" />
                      <Typography variant="caption">{device.battery}%</Typography>
                    </TableCell>
                    <TableCell>{device.lastUpdate}</TableCell>
                    <TableCell align="center">
                      <IconButton 
                        size="small" 
                        color="primary"
                        onClick={() => {
                          setEditingDevice(device);
                          setActiveSubmenu('edit-device');
                          setActiveMenu('devices');
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Box>
    );
  };



  const renderEditDevice = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Edit Device
      </Typography>
      <Card sx={{ p: 3, maxWidth: 600 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Device ID" variant="outlined" defaultValue={editingDevice?.deviceId || ''} required placeholder="e.g., DEV001" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Device Type</InputLabel>
              <Select label="Device Type" defaultValue={editingDevice?.type === 'GPS Tracker' ? 'gps-tracker' : editingDevice?.type === 'Smart Watch' ? 'smart-watch' : 'rfid-card'}>
                <MenuItem value="gps-tracker">GPS Tracker</MenuItem>
                <MenuItem value="smart-watch">Smart Watch</MenuItem>
                <MenuItem value="rfid-card">RFID Card</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="IMEI Number" variant="outlined" defaultValue={editingDevice?.imei_number || ''} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="SIM Number" variant="outlined" defaultValue={editingDevice?.sim_number || ''} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Model" variant="outlined" defaultValue={editingDevice?.model || ''} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Manufacturer" variant="outlined" defaultValue={editingDevice?.manufacturer || ''} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Purchase Date" variant="outlined" type="date" defaultValue="" InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select label="Status" defaultValue={editingDevice?.status || 'active'}>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
                <MenuItem value="maintenance">Maintenance</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth label="Notes" variant="outlined" multiline rows={2} defaultValue="" />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ mt: 2 }}>
              <Button 
                variant="contained" 
                color="primary" 
                sx={{ mr: 2 }}
                onClick={() => {
                  const formData = {
                    deviceId: document.querySelector('input[placeholder="e.g., DEV001"]').value,
                    type: 'GPS Tracker', // Get from form
                    status: 'Active' // Get from form
                  };
                  handleUpdateDevice(formData);
                }}
              >
                Update Device
              </Button>
              <Button variant="outlined" onClick={() => setActiveSubmenu('all-devices')}>
                Cancel
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );

  const renderImportDevices = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Import Device List
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Upload Excel File
            </Typography>
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <CloudUploadIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
              <Typography variant="body1" gutterBottom>
                Drag and drop your Excel file here or click to browse
              </Typography>
              <Button variant="contained" component="label" sx={{ mt: 2 }}>
                Choose File
                <input type="file" hidden accept=".xlsx,.xls" />
              </Button>
            </Box>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
              Supported formats: .xlsx, .xls (Max size: 10MB)
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Excel Format Requirements
            </Typography>
            <Typography variant="body2" paragraph>
              Your Excel file should contain the following columns:
            </Typography>
            <Box component="ul" sx={{ pl: 2 }}>
              <li>Device ID</li>
              <li>Device Type</li>
              <li>IMEI Number</li>
              <li>SIM Number</li>
              <li>Model</li>
              <li>Manufacturer</li>
              <li>Purchase Date</li>
              <li>Status</li>
              <li>Notes</li>
            </Box>
            <Button variant="outlined" sx={{ mt: 2 }}>
              Download Sample Template
            </Button>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );

  const renderDeviceAssignment = () => {
    const filteredDevices = devices.filter(device => {
      const matchesSearch = !assignmentFilters.deviceSearch || 
        (device.deviceId || device.id).toLowerCase().includes(assignmentFilters.deviceSearch.toLowerCase());
      const matchesType = !assignmentFilters.deviceType || device.type === assignmentFilters.deviceType;
      const isAssigned = students.some(student => student.device_id === device.deviceId);
      return matchesSearch && matchesType && !isAssigned;
    });

    const studentsWithoutDevice = students.filter(student => {
      const matchesSearch = !assignmentFilters.studentSearch || 
        `${student.first_name} ${student.last_name}`.toLowerCase().includes(assignmentFilters.studentSearch.toLowerCase());
      const matchesDivision = !assignmentFilters.division || student.division === assignmentFilters.division;
      const hasNoDevice = !student.device_id || student.device_id === '' || student.device_id === null;
      return matchesSearch && matchesDivision && hasNoDevice;
    });

    return (
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Assign Device to Student
        </Typography>
        
        {/* Filters */}
        <Card sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Filters
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                size="small"
                label="Search Device"
                placeholder="Device ID"
                value={assignmentFilters.deviceSearch}
                onChange={(e) => setAssignmentFilters(prev => ({...prev, deviceSearch: e.target.value}))}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Device Type</InputLabel>
                <Select
                  value={assignmentFilters.deviceType || ''}
                  label="Device Type"
                  onChange={(e) => setAssignmentFilters(prev => ({...prev, deviceType: e.target.value}))}
                >
                  <MenuItem value="">All Types</MenuItem>
                  <MenuItem value="GPS Tracker">GPS Tracker</MenuItem>
                  <MenuItem value="Smart Watch">Smart Watch</MenuItem>
                  <MenuItem value="RFID Card">RFID Card</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                size="small"
                label="Search Student"
                placeholder="Student Name"
                value={assignmentFilters.studentSearch}
                onChange={(e) => setAssignmentFilters(prev => ({...prev, studentSearch: e.target.value}))}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Division</InputLabel>
                <Select
                  value={assignmentFilters.division || ''}
                  label="Division"
                  onChange={(e) => setAssignmentFilters(prev => ({...prev, division: e.target.value}))}
                >
                  <MenuItem value="">All Divisions</MenuItem>
                  {divisions.map(div => (
                    <MenuItem key={div.id} value={div.name}>{div.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Card>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Available Devices ({filteredDevices.length})
              </Typography>
              <Box sx={{ border: 1, borderColor: 'grey.300', borderRadius: 1, minHeight: 300, maxHeight: 400, overflow: 'auto' }}>
                {filteredDevices.map(device => (
                  <Box
                    key={device.id}
                    onClick={() => handleAssignmentFormChange('deviceId', device.deviceId)}
                    sx={{
                      p: 2,
                      cursor: 'pointer',
                      borderBottom: 1,
                      borderColor: 'grey.200',
                      bgcolor: assignmentForm.deviceId === device.deviceId ? 'primary.light' : 'transparent',
                      color: assignmentForm.deviceId === device.deviceId ? 'white' : 'inherit',
                      '&:hover': {
                        bgcolor: assignmentForm.deviceId === device.deviceId ? 'primary.main' : 'grey.100'
                      }
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold">
                      {device.deviceId || device.id}
                    </Typography>
                    <Typography variant="caption" sx={{ opacity: 0.8 }}>
                      {device.type} - {device.status}
                    </Typography>
                  </Box>
                ))}
                {filteredDevices.length === 0 && (
                  <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
                    <Typography variant="body2">No devices available</Typography>
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Students without Device ({studentsWithoutDevice.length})
              </Typography>
              <Box sx={{ border: 1, borderColor: 'grey.300', borderRadius: 1, minHeight: 300, maxHeight: 400, overflow: 'auto' }}>
                {studentsWithoutDevice.map(student => (
                  <Box
                    key={student.id}
                    onClick={() => handleAssignmentFormChange('studentId', student.id)}
                    sx={{
                      p: 2,
                      cursor: 'pointer',
                      borderBottom: 1,
                      borderColor: 'grey.200',
                      bgcolor: assignmentForm.studentId === student.id ? 'primary.light' : 'transparent',
                      color: assignmentForm.studentId === student.id ? 'white' : 'inherit',
                      '&:hover': {
                        bgcolor: assignmentForm.studentId === student.id ? 'primary.main' : 'grey.100'
                      }
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold">
                      {student.first_name} {student.last_name}
                    </Typography>
                    <Typography variant="caption" sx={{ opacity: 0.8 }}>
                      {student.standard} - {student.division}
                    </Typography>
                  </Box>
                ))}
                {studentsWithoutDevice.length === 0 && (
                  <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
                    <Typography variant="body2">No students without devices</Typography>
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
          
          <Grid item xs={12}>
            <Card sx={{ p: 3 }}>
              <Box sx={{ textAlign: 'center' }}>
                <Button 
                  variant="contained" 
                  color="primary" 
                  sx={{ mr: 2 }}
                  onClick={handleAssignDevice}
                  disabled={loading || !assignmentForm.deviceId || !assignmentForm.studentId}
                >
                  {loading ? 'Assigning...' : 'Assign Device'}
                </Button>
                <Button variant="outlined" onClick={() => setActiveSubmenu('all-devices')}>
                  Cancel
                </Button>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const renderDeviceUnassignment = () => {
    const studentsWithDevice = students.filter((student) => {
      const matchesSearch = !connectedFilters.studentSearch ||
        `${student.first_name} ${student.last_name}`.toLowerCase().includes(connectedFilters.studentSearch.toLowerCase()) ||
        String(student.device_id || '').toLowerCase().includes(connectedFilters.studentSearch.toLowerCase()) ||
        String(student.roll_number || '').toLowerCase().includes(connectedFilters.studentSearch.toLowerCase());
      const matchesDivision = !connectedFilters.division || student.division === connectedFilters.division;
      const hasDevice = student.device_id && student.device_id !== '' && student.device_id !== null;
      return matchesSearch && matchesDivision && hasDevice;
    });

    return (
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Unassign Device from Student
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Search a student with a device, review details, then confirm twice to unassign.
          After unassign, the device can be assigned to another student.
        </Typography>

        <Card sx={{ p: 2, mb: 3 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6">Search Student</Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<RefreshIcon />}
              onClick={() => { loadStudents(); loadDevices(); }}
              disabled={loading}
            >
              Refresh
            </Button>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label="Search Student / Device / Roll"
                placeholder="Name, device ID or roll number"
                value={connectedFilters.studentSearch}
                onChange={(e) => setConnectedFilters((prev) => ({ ...prev, studentSearch: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Division</InputLabel>
                <Select
                  value={connectedFilters.division || ''}
                  label="Division"
                  onChange={(e) => setConnectedFilters((prev) => ({ ...prev, division: e.target.value }))}
                >
                  <MenuItem value="">All Divisions</MenuItem>
                  {divisions.map((div) => (
                    <MenuItem key={div.id} value={div.name}>{div.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => setConnectedFilters({ studentSearch: '', division: '' })}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </Card>

        <Card sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Students with Device ({studentsWithDevice.length})
          </Typography>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Student</TableCell>
                  <TableCell>Class / Div</TableCell>
                  <TableCell>Roll No</TableCell>
                  <TableCell>Device ID</TableCell>
                  <TableCell>Device Status</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {studentsWithDevice.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No students with assigned devices found
                    </TableCell>
                  </TableRow>
                ) : (
                  studentsWithDevice.map((student) => (
                    <TableRow key={student.id}>
                      <TableCell>
                        <Typography variant="body2" fontWeight="bold">
                          {student.first_name} {student.last_name}
                        </Typography>
                      </TableCell>
                      <TableCell>{student.standard || '-'} / {student.division || '-'}</TableCell>
                      <TableCell>{student.roll_number || '-'}</TableCell>
                      <TableCell>
                        <Typography variant="body2" color="primary" fontWeight="bold">
                          {student.device_id}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          label={student.device_status || 'assigned'}
                          color={student.device_status === 'active' ? 'success' : 'default'}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          size="small"
                          variant="contained"
                          color="error"
                          onClick={() => handleDisconnectDevice(student)}
                          disabled={loading}
                        >
                          Unassign Device
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Box>
    );
  };

  // Subscription Management Functions
  const renderPaymentCollection = () => {
    const filteredStudentsForPayment = students.filter(student => {
      const matchesSearch = !paymentFilters.studentSearch || 
        `${student.first_name} ${student.last_name}`.toLowerCase().includes(paymentFilters.studentSearch.toLowerCase());
      const matchesDivision = !paymentFilters.division || student.division === paymentFilters.division;
      return matchesSearch && matchesDivision;
    });

    return (
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Payment Collection
        </Typography>
        
        <Card sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Filter Students
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label="Search Student"
                placeholder="Student Name"
                value={paymentFilters.studentSearch}
                onChange={(e) => setPaymentFilters(prev => ({...prev, studentSearch: e.target.value}))}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Division</InputLabel>
                <Select
                  value={paymentFilters.division || ''}
                  label="Division"
                  onChange={(e) => setPaymentFilters(prev => ({...prev, division: e.target.value}))}
                >
                  <MenuItem value="">All Divisions</MenuItem>
                  {divisions.map(div => (
                    <MenuItem key={div.id} value={div.name}>{div.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Card>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Select Student ({filteredStudentsForPayment.length})
              </Typography>
              <Box sx={{ border: 1, borderColor: 'grey.300', borderRadius: 1, minHeight: 300, maxHeight: 400, overflow: 'auto' }}>
                {filteredStudentsForPayment.map(student => (
                  <Box
                    key={student.id}
                    onClick={() => setPaymentForm(prev => ({...prev, studentId: student.id}))}
                    sx={{
                      p: 2,
                      cursor: 'pointer',
                      borderBottom: 1,
                      borderColor: 'grey.200',
                      bgcolor: paymentForm.studentId === student.id ? 'primary.light' : 'transparent',
                      color: paymentForm.studentId === student.id ? 'white' : 'inherit',
                      '&:hover': {
                        bgcolor: paymentForm.studentId === student.id ? 'primary.main' : 'grey.100'
                      }
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold">
                      {student.first_name} {student.last_name}
                    </Typography>
                    <Typography variant="caption" sx={{ opacity: 0.8 }}>
                      {student.standard} - {student.division}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Payment Details
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Subscription Plan</InputLabel>
                    <Select
                      value={paymentForm.planId || ''}
                      label="Subscription Plan"
                      onChange={(e) => {
                        const plan = subscriptionPlans.find(p => p.id === e.target.value);
                        if (plan) {
                          const { base, tax, total } = calculateTax(plan.price);
                          setPaymentForm(prev => ({
                            ...prev, 
                            planId: e.target.value, 
                            baseAmount: plan.price,
                            taxAmount: tax.toFixed(2),
                            totalAmount: total.toFixed(2),
                            amount: total.toFixed(2)
                          }));
                        }
                      }}
                    >
                      {subscriptionPlans.length === 0 ? (
                        <MenuItem disabled>Loading plans...</MenuItem>
                      ) : (
                        subscriptionPlans.map(plan => (
                          <MenuItem key={plan.id} value={plan.id}>
                            {plan.name} - ₹{plan.price} ({plan.duration})
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                  {subscriptionPlans.length === 0 && (
                    <Typography variant="caption" color="error">
                      No subscription plans available. Check console for errors.
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Base Amount"
                    type="number"
                    value={paymentForm.baseAmount}
                    onChange={(e) => {
                      const { base, tax, total } = calculateTax(e.target.value);
                      setPaymentForm(prev => ({
                        ...prev, 
                        baseAmount: e.target.value,
                        taxAmount: tax.toFixed(2),
                        totalAmount: total.toFixed(2),
                        amount: total.toFixed(2)
                      }));
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label={`GST (${TAX_PERCENTAGE}%)`}
                    type="number"
                    value={paymentForm.taxAmount}
                    InputProps={{ readOnly: true }}
                    sx={{ bgcolor: 'grey.100' }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Total Amount (Including GST)"
                    type="number"
                    value={paymentForm.totalAmount}
                    InputProps={{ readOnly: true }}
                    sx={{ bgcolor: 'primary.light', '& input': { fontWeight: 'bold', fontSize: '1.1rem' } }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Payment Method</InputLabel>
                    <Select
                      value={paymentForm.paymentMethod || 'cash'}
                      label="Payment Method"
                      onChange={(e) => setPaymentForm(prev => ({...prev, paymentMethod: e.target.value}))}
                    >
                      <MenuItem value="cash">Cash</MenuItem>
                      <MenuItem value="upi">UPI</MenuItem>
                      <MenuItem value="card">Card</MenuItem>
                      <MenuItem value="bank-transfer">Bank Transfer</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Payment Date"
                    type="date"
                    value={paymentForm.paymentDate}
                    onChange={(e) => setPaymentForm(prev => ({...prev, paymentDate: e.target.value}))}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    fullWidth
                    onClick={handleCollectPayment}
                    disabled={loading || !paymentForm.studentId || !paymentForm.planId}
                  >
                    {loading ? 'Processing...' : 'Collect Payment'}
                  </Button>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const renderSubscriptionStatus = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Subscription Status
      </Typography>
      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Student</TableCell>
                <TableCell>Plan</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Expires On</TableCell>
                <TableCell>Days Left</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {students.map((student) => {
                const daysLeft = student.days_remaining || 0;
                const status = student.subscription_display_status || 'No Plan';
                const planName = student.plan_name || 'No Plan';
                
                // Calculate expiry date based on days remaining
                const expiryDate = daysLeft > 0 
                  ? new Date(Date.now() + daysLeft * 24 * 60 * 60 * 1000).toLocaleDateString()
                  : 'N/A';
                
                return (
                  <TableRow key={student.id}>
                    <TableCell>
                      <Typography variant="body2" fontWeight="bold">
                        {student.first_name} {student.last_name}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {student.standard} - {student.division}
                      </Typography>
                    </TableCell>
                    <TableCell>{planName}</TableCell>
                    <TableCell>
                      <Chip 
                        label={status} 
                        color={
                          status === 'Active' ? 'success' : 
                          status === 'Expiring Soon' ? 'warning' : 'error'
                        } 
                        size="small" 
                      />
                    </TableCell>
                    <TableCell>{expiryDate}</TableCell>
                    <TableCell>{daysLeft} days</TableCell>
                    <TableCell align="center">
                      <Button 
                        size="small" 
                        variant="outlined"
                        onClick={() => {
                          setPaymentForm(prev => ({...prev, studentId: student.id}));
                          setActiveSubmenu('payment-collection');
                        }}
                      >
                        Renew
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );

  const renderCommissionFilters = () => (
    <Card sx={{ p: 2, mb: 3 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            size="small"
            type="date"
            label="From Date"
            InputLabelProps={{ shrink: true }}
            value={commissionFilters.start_date}
            onChange={(e) => setCommissionFilters((prev) => ({ ...prev, start_date: e.target.value }))}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            size="small"
            type="date"
            label="To Date"
            InputLabelProps={{ shrink: true }}
            value={commissionFilters.end_date}
            onChange={(e) => setCommissionFilters((prev) => ({ ...prev, end_date: e.target.value }))}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            fullWidth
            size="small"
            label="Standard"
            value={commissionFilters.standard}
            onChange={(e) => setCommissionFilters((prev) => ({ ...prev, standard: e.target.value }))}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            fullWidth
            size="small"
            label="Division"
            value={commissionFilters.division}
            onChange={(e) => setCommissionFilters((prev) => ({ ...prev, division: e.target.value }))}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                loadCommissionSummary();
                const groupMap = {
                  'commission-summary': 'detail',
                  'commission-date-report': 'date',
                  'commission-division-report': 'division',
                  'commission-detail-report': 'detail',
                  'commission-event-report': 'event'
                };
                loadCommissionReports(groupMap[activeSubmenu] || 'detail');
              }}
            >
              Apply
            </Button>
            <Button fullWidth variant="outlined" onClick={resetCommissionFilters}>
              Reset
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );

  const renderCommissionContent = () => {
    if (activeSubmenu === 'commission-withdrawal') {
      return (
        <Box sx={{ flexGrow: 1, p: 3 }}>
          <Typography variant="h4" gutterBottom fontWeight="bold">
            Commission Withdrawal
          </Typography>

          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h4" color="warning.main">
                  ₹{Number(commissionSummary.available_balance || 0).toLocaleString()}
                </Typography>
                <Typography variant="body2">Available Commission</Typography>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h4" color="success.main">
                  ₹{Number(commissionSummary.total_withdrawn || commissionSummary.total_paid || 0).toLocaleString()}
                </Typography>
                <Typography variant="body2">Total Withdrawn / Paid</Typography>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h4" color="primary">
                  ₹{Number(commissionSummary.total_accrued || 0).toLocaleString()}
                </Typography>
                <Typography variant="body2">Total Earned</Typography>
              </Card>
            </Grid>
          </Grid>

          <Card sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" gutterBottom>Withdrawal Form</Typography>
            {withdrawalMessage ? (
              <Alert severity={withdrawalMessage.includes('success') ? 'success' : 'error'} sx={{ mb: 2 }}>
                {withdrawalMessage}
              </Alert>
            ) : null}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Account Holder Name"
                  value={withdrawalForm.account_holder_name}
                  onChange={(e) => setWithdrawalForm((prev) => ({ ...prev, account_holder_name: e.target.value }))}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Bank Name"
                  value={withdrawalForm.bank_name}
                  onChange={(e) => setWithdrawalForm((prev) => ({ ...prev, bank_name: e.target.value }))}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  required
                  label="Account Number"
                  value={withdrawalForm.account_number}
                  onChange={(e) => setWithdrawalForm((prev) => ({ ...prev, account_number: e.target.value }))}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  required
                  label="IFSC Code"
                  value={withdrawalForm.ifsc_code}
                  onChange={(e) => setWithdrawalForm((prev) => ({ ...prev, ifsc_code: e.target.value.toUpperCase() }))}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  required
                  type="number"
                  label="Amount"
                  helperText={`Max available: ₹${Number(commissionSummary.available_balance || 0).toFixed(2)}`}
                  value={withdrawalForm.amount}
                  onChange={(e) => setWithdrawalForm((prev) => ({ ...prev, amount: e.target.value }))}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Notes (optional)"
                  value={withdrawalForm.notes}
                  onChange={(e) => setWithdrawalForm((prev) => ({ ...prev, notes: e.target.value }))}
                />
              </Grid>
              <Grid item xs={12}>
                <Button variant="contained" disabled={withdrawalLoading} onClick={submitCommissionWithdrawal}>
                  {withdrawalLoading ? 'Submitting...' : 'Submit Withdrawal'}
                </Button>
              </Grid>
            </Grid>
          </Card>

          <Card sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Transactions (Credits + Withdrawals)</Typography>
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  label="From Date"
                  InputLabelProps={{ shrink: true }}
                  value={commissionFilters.start_date}
                  onChange={(e) => setCommissionFilters((prev) => ({ ...prev, start_date: e.target.value }))}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  label="To Date"
                  InputLabelProps={{ shrink: true }}
                  value={commissionFilters.end_date}
                  onChange={(e) => setCommissionFilters((prev) => ({ ...prev, end_date: e.target.value }))}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button fullWidth variant="outlined" onClick={() => loadCommissionTransactions()}>
                  Filter
                </Button>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button fullWidth variant="outlined" color="secondary" onClick={resetCommissionFilters}>
                  Reset
                </Button>
              </Grid>
            </Grid>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Details</TableCell>
                    <TableCell>Requested By</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {commissionTransactions.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center">No transactions found</TableCell>
                    </TableRow>
                  ) : (
                    commissionTransactions.map((txn) => (
                      <TableRow key={`${txn.txn_type}-${txn.id}`}>
                        <TableCell>{new Date(txn.created_at).toLocaleString()}</TableCell>
                        <TableCell>{txn.txn_type === 'withdrawal' ? 'Withdrawal' : 'Commission In'}</TableCell>
                        <TableCell>
                          {txn.txn_type === 'withdrawal'
                            ? `A/C ${txn.account_number || '-'} / IFSC ${txn.ifsc_code || '-'}`
                            : `${txn.event_type || '-'} ${txn.device_id ? `(${txn.device_id})` : ''}`}
                        </TableCell>
                        <TableCell>
                          {txn.txn_type === 'withdrawal'
                            ? `${txn.requested_by_name || '-'} ${txn.requested_by_email ? `(${txn.requested_by_email})` : ''}`
                            : '-'}
                        </TableCell>
                        <TableCell sx={{ color: txn.txn_type === 'withdrawal' ? 'error.main' : 'success.main' }}>
                          {txn.txn_type === 'withdrawal' ? '-' : '+'}₹{Number(txn.amount || 0).toLocaleString()}
                        </TableCell>
                        <TableCell>{txn.status}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Box>
      );
    }

    const isGrouped = ['commission-date-report', 'commission-division-report', 'commission-event-report'].includes(activeSubmenu);
    const titleMap = {
      'commission-summary': 'Commission Summary',
      'commission-date-report': 'Date-wise Commission Report',
      'commission-division-report': 'Division-wise Commission Report',
      'commission-event-report': 'Payment Source Commission Report',
      'commission-detail-report': 'Commission Ledger'
    };

    return (
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          {titleMap[activeSubmenu] || 'Commission'}
        </Typography>

        {renderCommissionFilters()}

        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} md={3}>
            <Card sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h4" color="primary">₹{Number(commissionSummary.total_accrued || 0).toLocaleString()}</Typography>
              <Typography variant="body2">Total Commission</Typography>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h4" color="warning.main">₹{Number(commissionSummary.total_pending || 0).toLocaleString()}</Typography>
              <Typography variant="body2">Pending</Typography>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h4" color="success.main">₹{Number(commissionSummary.total_paid || 0).toLocaleString()}</Typography>
              <Typography variant="body2">Paid</Typography>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h4" color="info.main">{formatCommissionRate(commissionSummary)}</Typography>
              <Typography variant="body2">
                School Commission Rate
                {commissionSummary.school_name ? ` (${commissionSummary.school_name})` : ''}
              </Typography>
            </Card>
          </Grid>
        </Grid>

        <Card sx={{ p: 3 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {isGrouped ? (
                    <>
                      <TableCell>Group</TableCell>
                      <TableCell>Entries</TableCell>
                      <TableCell>Base Amount</TableCell>
                      <TableCell>Commission</TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell>Date</TableCell>
                      <TableCell>Event</TableCell>
                      <TableCell>Device</TableCell>
                      <TableCell>Class/Div</TableCell>
                      <TableCell>Base</TableCell>
                      <TableCell>Rate</TableCell>
                      <TableCell>Commission</TableCell>
                      <TableCell>Status</TableCell>
                    </>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {commissionReports.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={isGrouped ? 4 : 8} align="center">
                      No commission records yet. Run DB migration and collect a payment to see data.
                    </TableCell>
                  </TableRow>
                ) : isGrouped ? (
                  commissionReports.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.report_label || row.report_key}</TableCell>
                      <TableCell>{row.entry_count}</TableCell>
                      <TableCell>₹{Number(row.total_base_amount || 0).toLocaleString()}</TableCell>
                      <TableCell>₹{Number(row.total_commission || 0).toLocaleString()}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  commissionReports.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{new Date(row.created_at).toLocaleDateString()}</TableCell>
                      <TableCell>{row.event_type}</TableCell>
                      <TableCell>{row.device_id || '-'}</TableCell>
                      <TableCell>{row.standard || '-'} / {row.division || '-'}</TableCell>
                      <TableCell>₹{Number(row.commission_base_amount || 0).toLocaleString()}</TableCell>
                      <TableCell>{row.commission_type === 'fixed' ? `₹${row.commission_rate}` : `${row.commission_rate}%`}</TableCell>
                      <TableCell>₹{Number(row.commission_amount || 0).toLocaleString()}</TableCell>
                      <TableCell>{row.status}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Box>
    );
  };

  const renderDeviceSalesReport = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Device Sales Report
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Devices sold/assigned from this school to students.
      </Typography>

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} md={4}>
          <Card sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h4" color="primary">{deviceSalesSummary.total_devices || 0}</Typography>
            <Typography variant="body2">Total Devices</Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h4" color="success.main">{deviceSalesSummary.sold_to_student || 0}</Typography>
            <Typography variant="body2">Sold to Student</Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h4" color="warning.main">{deviceSalesSummary.school_inventory || 0}</Typography>
            <Typography variant="body2">School Inventory</Typography>
          </Card>
        </Grid>
      </Grid>

      <Card sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size="small"
              label="Standard"
              value={deviceSalesFilters.standard}
              onChange={(e) => setDeviceSalesFilters((prev) => ({ ...prev, standard: e.target.value }))}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size="small"
              label="Division"
              value={deviceSalesFilters.division}
              onChange={(e) => setDeviceSalesFilters((prev) => ({ ...prev, division: e.target.value }))}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Status</InputLabel>
              <Select
                label="Status"
                value={deviceSalesFilters.assignment_status}
                onChange={(e) => setDeviceSalesFilters((prev) => ({ ...prev, assignment_status: e.target.value }))}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="sold_to_student">Sold to Student</MenuItem>
                <MenuItem value="school_inventory">School Inventory</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button fullWidth variant="contained" onClick={() => loadDeviceSalesReport()}>Apply</Button>
              <Button fullWidth variant="outlined" onClick={resetDeviceSalesFilters}>Reset</Button>
            </Box>
          </Grid>
        </Grid>
      </Card>

      <Card sx={{ p: 3 }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Device ID</TableCell>
                <TableCell>Type / Model</TableCell>
                <TableCell>Student</TableCell>
                <TableCell>Class / Div</TableCell>
                <TableCell>Roll No</TableCell>
                <TableCell>Sale Status</TableCell>
                <TableCell>Device Status</TableCell>
                <TableCell>Added On</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {deviceSalesReports.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">No device sales records found</TableCell>
                </TableRow>
              ) : (
                deviceSalesReports.map((row) => (
                  <TableRow key={row.id || row.device_id}>
                    <TableCell>{row.device_id}</TableCell>
                    <TableCell>{row.type || '-'}{row.model ? ` / ${row.model}` : ''}</TableCell>
                    <TableCell>{(row.student_name || '').trim() || '-'}</TableCell>
                    <TableCell>{row.standard || '-'} / {row.division || '-'}</TableCell>
                    <TableCell>{row.roll_number || '-'}</TableCell>
                    <TableCell>{row.sale_status === 'sold_to_student' ? 'Sold to Student' : 'School Inventory'}</TableCell>
                    <TableCell>{row.device_status || '-'}</TableCell>
                    <TableCell>{row.created_at ? new Date(row.created_at).toLocaleDateString() : '-'}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );

  const renderPaymentReports = () => {
    const reportsArray = Array.isArray(paymentReports) ? paymentReports : [];
    console.log('Rendering payment reports:', reportsArray);
    const totalAmount = reportsArray.reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0);
    const thisMonthAmount = reportsArray.filter(p => new Date(p.payment_date).getMonth() === new Date().getMonth()).reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0);
    console.log('Total amount:', totalAmount, 'This month:', thisMonthAmount);
    
    return (
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Payment Reports
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h4" color="primary">₹{thisMonthAmount.toLocaleString()}</Typography>
              <Typography variant="body2">Total Collection (This Month)</Typography>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h4" color="success.main">₹{totalAmount.toLocaleString()}</Typography>
              <Typography variant="body2">Total Collection (All Time)</Typography>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h4" color="info.main">{reportsArray.length}</Typography>
              <Typography variant="body2">Total Payments</Typography>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Recent Payments
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Student</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>Method</TableCell>
                      <TableCell>Plan</TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reportsArray.map((payment, i) => (
                      <TableRow key={i}>
                        <TableCell>{new Date(payment.payment_date).toLocaleDateString()}</TableCell>
                        <TableCell>{payment.first_name} {payment.last_name}</TableCell>
                        <TableCell>₹{payment.amount}</TableCell>
                        <TableCell>{payment.payment_method}</TableCell>
                        <TableCell>{payment.plan_name}</TableCell>
                        <TableCell align="center">
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => {
                              setSelectedPayment(payment);
                              setPaymentDetailsDialog(true);
                            }}
                          >
                            Details
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const renderParentAccounts = () => {
    const filteredParents = parentAccounts.filter(parent => {
      const matchesSearch = !parentFilters.search || 
        `${parent.first_name} ${parent.last_name}`.toLowerCase().includes(parentFilters.search.toLowerCase()) ||
        parent.email.toLowerCase().includes(parentFilters.search.toLowerCase());
      const matchesStatus = !parentFilters.status || parent.status === parentFilters.status;
      return matchesSearch && matchesStatus;
    });

    return (
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h4" fontWeight="bold">
            Parent Accounts
          </Typography>
        </Box>
        
        <Card sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Filters
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label="Search"
                placeholder="Name or Email"
                value={parentFilters.search}
                onChange={(e) => setParentFilters(prev => ({...prev, search: e.target.value}))}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select
                  value={parentFilters.status || ''}
                  label="Status"
                  onChange={(e) => setParentFilters(prev => ({...prev, status: e.target.value}))}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => setParentFilters({ search: '', status: '' })}
                sx={{ minWidth: 'auto', px: 1 }}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
          <Box mt={2}>
            <Typography variant="body2" color="textSecondary">
              Showing {filteredParents.length} of {parentAccounts.length} parents
            </Typography>
          </Box>
        </Card>
        
        <Card>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Parent Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Phone</TableCell>
                  <TableCell>Children</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredParents.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="body2" color="textSecondary">
                        {parentAccounts.length === 0 ? 'No parent accounts found.' : 'No parents match the current filters.'}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredParents.map((parent) => (
                    <TableRow key={parent.id}>
                    <TableCell>
                      <Typography variant="body2" fontWeight="bold">
                        {parent.first_name} {parent.last_name}
                      </Typography>
                    </TableCell>
                    <TableCell>{parent.email}</TableCell>
                    <TableCell>{parent.phone}</TableCell>
                    <TableCell>{parent.children_count || 0}</TableCell>
                    <TableCell>
                      <Chip 
                        label={parent.status} 
                        color={parent.status === 'active' ? 'success' : 'error'} 
                        size="small" 
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleEditParent(parent)}
                        sx={{ mr: 1 }}
                      >
                        Edit
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {
                          setResetPasswordForm({
                            parentId: parent.id,
                            parentName: `${parent.first_name} ${parent.last_name}`,
                            newPassword: ''
                          });
                          setResetPasswordDialog(true);
                        }}
                        sx={{ mr: 1 }}
                      >
                        Reset Password
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        color="error"
                        onClick={() => handleDeleteParent(parent.id, `${parent.first_name} ${parent.last_name}`)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Box>
    );
  };

  const renderAssignStudentsToParent = () => {
    const filteredStudentsForAssignment = students.filter(student => {
      const matchesSearch = !assignStudentsForm.searchTerm || 
        `${student.first_name} ${student.last_name}`.toLowerCase().includes(assignStudentsForm.searchTerm.toLowerCase()) ||
        student.roll_number?.toString().includes(assignStudentsForm.searchTerm);
      return matchesSearch;
    });

    const filteredParents = parentAccounts.filter(parent => {
      const matchesSearch = !assignStudentsForm.parentSearchTerm || 
        `${parent.first_name} ${parent.last_name}`.toLowerCase().includes(assignStudentsForm.parentSearchTerm.toLowerCase()) ||
        parent.email.toLowerCase().includes(assignStudentsForm.parentSearchTerm.toLowerCase());
      return matchesSearch;
    });

    const handleStudentToggleForAssignment = (studentId) => {
      setAssignStudentsForm(prev => ({
        ...prev,
        selectedStudents: prev.selectedStudents.includes(studentId)
          ? prev.selectedStudents.filter(id => id !== studentId)
          : [...prev.selectedStudents, studentId]
      }));
    };

    return (
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Assign Students to Parent
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Select Parent
              </Typography>
              <TextField
                fullWidth
                size="small"
                label="Search Parent"
                placeholder="Name or Email"
                value={assignStudentsForm.parentSearchTerm}
                onChange={(e) => setAssignStudentsForm(prev => ({...prev, parentSearchTerm: e.target.value}))}
                sx={{ mb: 2 }}
              />
              
              <Box sx={{ border: 1, borderColor: 'grey.300', borderRadius: 1, maxHeight: 200, overflow: 'auto', mb: 2 }}>
                {filteredParents.map(parent => (
                  <Box
                    key={parent.id}
                    onClick={() => setAssignStudentsForm(prev => ({...prev, parentId: parent.id}))}
                    sx={{
                      p: 2,
                      cursor: 'pointer',
                      borderBottom: 1,
                      borderColor: 'grey.200',
                      bgcolor: assignStudentsForm.parentId === parent.id ? 'primary.light' : 'transparent',
                      color: assignStudentsForm.parentId === parent.id ? 'white' : 'inherit',
                      '&:hover': {
                        bgcolor: assignStudentsForm.parentId === parent.id ? 'primary.main' : 'grey.100'
                      }
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold">
                      {parent.first_name} {parent.last_name}
                    </Typography>
                    <Typography variant="caption" sx={{ opacity: 0.8 }}>
                      {parent.email}
                    </Typography>
                  </Box>
                ))}
                {filteredParents.length === 0 && (
                  <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
                    <Typography variant="body2">No parents found</Typography>
                  </Box>
                )}
              </Box>
              
              <Typography variant="h6" gutterBottom>
                Search & Select Students ({assignStudentsForm.selectedStudents.length} selected)
              </Typography>
              
              <TextField
                fullWidth
                size="small"
                label="Search Students"
                placeholder="Name or Roll Number"
                value={assignStudentsForm.searchTerm}
                onChange={(e) => setAssignStudentsForm(prev => ({...prev, searchTerm: e.target.value}))}
                sx={{ mb: 2 }}
              />
              
              <Box sx={{ border: 1, borderColor: 'grey.300', borderRadius: 1, maxHeight: 400, overflow: 'auto' }}>
                {filteredStudentsForAssignment.map(student => (
                  <Box
                    key={student.id}
                    onClick={() => handleStudentToggleForAssignment(student.id)}
                    sx={{
                      p: 2,
                      cursor: 'pointer',
                      borderBottom: 1,
                      borderColor: 'grey.200',
                      bgcolor: assignStudentsForm.selectedStudents.includes(student.id) ? 'primary.light' : 'transparent',
                      color: assignStudentsForm.selectedStudents.includes(student.id) ? 'white' : 'inherit',
                      '&:hover': {
                        bgcolor: assignStudentsForm.selectedStudents.includes(student.id) ? 'primary.main' : 'grey.100'
                      },
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Box sx={{ mr: 2 }}>
                      {assignStudentsForm.selectedStudents.includes(student.id) ? '✓' : '○'}
                    </Box>
                    <Box>
                      <Typography variant="body2" fontWeight="bold">
                        {student.first_name} {student.last_name}
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.8 }}>
                        {student.standard} - {student.division} (Roll: {student.roll_number})
                      </Typography>
                    </Box>
                  </Box>
                ))}
                {filteredStudentsForAssignment.length === 0 && (
                  <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
                    <Typography variant="body2">No students found</Typography>
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Selected Students ({assignStudentsForm.selectedStudents.length})
              </Typography>
              
              <Box sx={{ border: 1, borderColor: 'grey.300', borderRadius: 1, minHeight: 300, maxHeight: 400, overflow: 'auto' }}>
                {assignStudentsForm.selectedStudents.map(studentId => {
                  const student = students.find(s => s.id === studentId);
                  if (!student) return null;
                  return (
                    <Box
                      key={student.id}
                      sx={{
                        p: 2,
                        borderBottom: 1,
                        borderColor: 'grey.200',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <Box>
                        <Typography variant="body2" fontWeight="bold">
                          {student.first_name} {student.last_name}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {student.standard} - {student.division} (Roll: {student.roll_number})
                        </Typography>
                      </Box>
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handleStudentToggleForAssignment(student.id)}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  );
                })}
                {assignStudentsForm.selectedStudents.length === 0 && (
                  <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
                    <Typography variant="body2">No students selected</Typography>
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
          
          <Grid item xs={12}>
            <Card sx={{ p: 3 }}>
              <Box sx={{ textAlign: 'center' }}>
                <Button 
                  variant="contained" 
                  sx={{ mr: 2 }}
                  onClick={handleAssignStudentsToParent}
                  disabled={loading || !assignStudentsForm.parentId || assignStudentsForm.selectedStudents.length === 0}
                >
                  {loading ? 'Assigning...' : 'Assign Students to Parent'}
                </Button>
                <Button 
                  variant="outlined" 
                  onClick={() => {
                    setActiveSubmenu('parent-accounts');
                    setAssignStudentsForm({
                      parentId: '',
                      selectedStudents: [],
                      searchTerm: '',
                      parentSearchTerm: ''
                    });
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const renderCreateParentLogin = () => {
    const filteredStudentsForParent = students.filter(student => {
      const matchesSearch = !studentFilters.search || 
        `${student.first_name} ${student.last_name}`.toLowerCase().includes(studentFilters.search.toLowerCase());
      const matchesStandard = !studentFilters.standard || student.standard === studentFilters.standard;
      const matchesDivision = !studentFilters.division || student.division === studentFilters.division;
      return matchesSearch && matchesStandard && matchesDivision;
    });

    const handleStudentToggle = (studentId) => {
      setCreateParentForm(prev => ({
        ...prev,
        selectedStudents: prev.selectedStudents.includes(studentId)
          ? prev.selectedStudents.filter(id => id !== studentId)
          : [...prev.selectedStudents, studentId]
      }));
    };

    return (
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Create Parent Login
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Parent Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField 
                    fullWidth 
                    label="First Name" 
                    required 
                    value={createParentForm.firstName}
                    onChange={(e) => setCreateParentForm(prev => ({...prev, firstName: e.target.value}))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField 
                    fullWidth 
                    label="Last Name" 
                    required 
                    value={createParentForm.lastName}
                    onChange={(e) => setCreateParentForm(prev => ({...prev, lastName: e.target.value}))}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    fullWidth 
                    label="Email" 
                    type="email" 
                    required 
                    value={createParentForm.email}
                    onChange={(e) => setCreateParentForm(prev => ({...prev, email: e.target.value}))}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    fullWidth 
                    label="Phone Number" 
                    required 
                    value={createParentForm.phone}
                    onChange={(e) => setCreateParentForm(prev => ({...prev, phone: e.target.value}))}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    fullWidth 
                    label="Password" 
                    type="password" 
                    required 
                    value={createParentForm.password}
                    onChange={(e) => setCreateParentForm(prev => ({...prev, password: e.target.value}))}
                    helperText="Minimum 6 characters"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    fullWidth 
                    label="Address" 
                    multiline 
                    rows={2} 
                    value={createParentForm.address}
                    onChange={(e) => setCreateParentForm(prev => ({...prev, address: e.target.value}))}
                  />
                </Grid>
              </Grid>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Select Children ({createParentForm.selectedStudents.length} selected)
              </Typography>
              
              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Search Student"
                    placeholder="Student Name"
                    value={studentFilters.search}
                    onChange={(e) => setStudentFilters(prev => ({...prev, search: e.target.value}))}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Standard</InputLabel>
                    <Select
                      value={studentFilters.standard || ''}
                      label="Standard"
                      onChange={(e) => setStudentFilters(prev => ({...prev, standard: e.target.value}))}
                    >
                      <MenuItem value="">All</MenuItem>
                      {standards.map(std => (
                        <MenuItem key={std.id} value={std.name}>{std.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Division</InputLabel>
                    <Select
                      value={studentFilters.division || ''}
                      label="Division"
                      onChange={(e) => setStudentFilters(prev => ({...prev, division: e.target.value}))}
                    >
                      <MenuItem value="">All</MenuItem>
                      {divisions.map(div => (
                        <MenuItem key={div.id} value={div.name}>{div.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              
              <Box sx={{ border: 1, borderColor: 'grey.300', borderRadius: 1, maxHeight: 300, overflow: 'auto' }}>
                {filteredStudentsForParent.map(student => (
                  <Box
                    key={student.id}
                    onClick={() => handleStudentToggle(student.id)}
                    sx={{
                      p: 2,
                      cursor: 'pointer',
                      borderBottom: 1,
                      borderColor: 'grey.200',
                      bgcolor: createParentForm.selectedStudents.includes(student.id) ? 'primary.light' : 'transparent',
                      color: createParentForm.selectedStudents.includes(student.id) ? 'white' : 'inherit',
                      '&:hover': {
                        bgcolor: createParentForm.selectedStudents.includes(student.id) ? 'primary.main' : 'grey.100'
                      },
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Box sx={{ mr: 2 }}>
                      {createParentForm.selectedStudents.includes(student.id) ? '✓' : '○'}
                    </Box>
                    <Box>
                      <Typography variant="body2" fontWeight="bold">
                        {student.first_name} {student.last_name}
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.8 }}>
                        {student.standard} - {student.division} (Roll: {student.roll_number})
                      </Typography>
                    </Box>
                  </Box>
                ))}
                {filteredStudentsForParent.length === 0 && (
                  <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
                    <Typography variant="body2">No students found</Typography>
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
          
          <Grid item xs={12}>
            <Card sx={{ p: 3 }}>
              <Box sx={{ textAlign: 'center' }}>
                <Button 
                  variant="contained" 
                  sx={{ mr: 2 }}
                  onClick={handleCreateParent}
                  disabled={loading || !createParentForm.firstName || !createParentForm.lastName || !createParentForm.email || !createParentForm.phone || !createParentForm.password || createParentForm.selectedStudents.length === 0}
                >
                  {loading ? 'Creating...' : 'Create Parent Account'}
                </Button>
                <Button 
                  variant="outlined" 
                  onClick={() => {
                    setActiveSubmenu('parent-accounts');
                    setCreateParentForm({
                      firstName: '',
                      lastName: '',
                      email: '',
                      phone: '',
                      address: '',
                      password: '',
                      selectedStudents: []
                    });
                    setStudentFilters({ search: '', standard: '', division: '' });
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const renderResetParentPassword = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Reset Parent Password
      </Typography>
      <Card sx={{ p: 3, maxWidth: 600 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Select Parent</InputLabel>
              <Select
                value={resetPasswordForm.parentId || ''}
                onChange={(e) => {
                  const parent = parentAccounts.find(p => p.id === e.target.value);
                  setResetPasswordForm({
                    parentId: e.target.value,
                    parentName: parent ? `${parent.first_name} ${parent.last_name}` : '',
                    newPassword: resetPasswordForm.newPassword
                  });
                }}
              >
                {parentAccounts.map(parent => (
                  <MenuItem key={parent.id} value={parent.id}>
                    {parent.first_name} {parent.last_name} - {parent.email}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="New Password" 
              type="password"
              value={resetPasswordForm.newPassword}
              onChange={(e) => setResetPasswordForm(prev => ({...prev, newPassword: e.target.value}))}
              helperText="Minimum 6 characters required"
            />
          </Grid>
          <Grid item xs={12}>
            <Button 
              variant="contained" 
              sx={{ mr: 2 }}
              onClick={handleResetPassword}
              disabled={loading || !resetPasswordForm.parentId || !resetPasswordForm.newPassword}
            >
              {loading ? 'Resetting...' : 'Reset Password'}
            </Button>
            <Button variant="outlined" onClick={() => {
              setActiveSubmenu('parent-accounts');
              setResetPasswordForm({ parentId: '', parentName: '', newPassword: '' });
            }}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );

  const renderParentNotifications = () => (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Send Parent Notifications
      </Typography>
      <Card sx={{ p: 3, maxWidth: 800 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Select Parents</InputLabel>
              <Select 
                multiple
                value={notificationForm.selectedParents || []}
                onChange={(e) => setNotificationForm(prev => ({...prev, selectedParents: e.target.value}))}
                MenuProps={SELECT_MENU_PROPS}
              >
                {parentAccounts.map(parent => (
                  <MenuItem key={parent.id} value={parent.id}>
                    {parent.first_name} {parent.last_name} - {parent.email}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="Message Title" 
              required 
              value={notificationForm.title}
              onChange={(e) => setNotificationForm(prev => ({...prev, title: e.target.value}))}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="Message" 
              multiline 
              rows={4} 
              required 
              value={notificationForm.message}
              onChange={(e) => setNotificationForm(prev => ({...prev, message: e.target.value}))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Message Type</InputLabel>
              <Select 
                value={notificationForm.type}
                onChange={(e) => setNotificationForm(prev => ({...prev, type: e.target.value}))}
              >
                <MenuItem value="info">Information</MenuItem>
                <MenuItem value="warning">Warning</MenuItem>
                <MenuItem value="urgent">Urgent</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Button 
              variant="contained" 
              sx={{ mr: 2 }}
              onClick={handleSendNotification}
            >
              Send Notification
            </Button>
            <Button 
              variant="outlined"
              onClick={() => setNotificationForm(prev => ({...prev, selectedParents: parentAccounts.map(p => p.id)}))}
            >
              Send to All Parents
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );

  const renderRenewalReminders = () => {
    const getDaysRemaining = (student) => {
      const raw = student?.days_remaining;
      const value = typeof raw === 'string' ? Number(raw) : raw;
      return Number.isFinite(value) ? value : null;
    };

    const expiringSoon = students.filter((student) => {
      const days = getDaysRemaining(student);
      return days !== null && days > 0 && days <= 7;
    });

    const expiredSubscriptions = students.filter((student) => {
      const days = getDaysRemaining(student);
      if (days !== null) {
        return days <= 0;
      }
      return student.subscription_display_status?.toLowerCase().includes('expired');
    });

    const renderStudentChip = (student, copy) => (
      <Box key={student.id} sx={{ mb: 2, p: 2, bgcolor: copy.backgroundColor, borderRadius: 1 }}>
        <Typography variant="body2" fontWeight="bold">
          {student.first_name} {student.last_name}
        </Typography>
        <Typography variant="caption" display="block">
          {copy.message(student)}
        </Typography>
        {copy.actions(student)}
      </Box>
    );

    return (
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Renewal Reminders
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom color="warning.main">
                Expiring Soon (≤ 7 days)
              </Typography>
              {expiringSoon.length === 0 && (
                <Typography variant="body2" color="text.secondary">
                  No subscriptions expiring within the next week.
                </Typography>
              )}
              {expiringSoon.map((student) =>
                renderStudentChip(student, {
                  backgroundColor: 'warning.light',
                  message: (s) => {
                    const days = getDaysRemaining(s);
                    return days !== null ? `Expires in ${days} day${days === 1 ? '' : 's'}` : 'Expiry date unavailable';
                  },
                  actions: () => (
                    <Box sx={{ mt: 1 }}>
                      <Button size="small" variant="outlined" sx={{ mr: 1 }}>
                        Send Reminder
                      </Button>
                      <Button size="small" variant="contained">
                        Renew Now
                      </Button>
                    </Box>
                  )
                })
              )}
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom color="error.main">
                Expired Subscriptions
              </Typography>
              {expiredSubscriptions.length === 0 && (
                <Typography variant="body2" color="text.secondary">
                  No expired subscriptions.
                </Typography>
              )}
              {expiredSubscriptions.map((student) =>
                renderStudentChip(student, {
                  backgroundColor: 'error.light',
                  message: (s) => {
                    const days = getDaysRemaining(s);
                    if (days !== null) {
                      const daysAgo = Math.abs(days);
                      return days <= 0
                        ? `Expired ${daysAgo} day${daysAgo === 1 ? '' : 's'} ago`
                        : `Expires in ${days} day${days === 1 ? '' : 's'}`;
                    }
                    return 'Expiry date unavailable';
                  },
                  actions: () => (
                    <Box sx={{ mt: 1 }}>
                      <Button size="small" variant="contained" color="error">
                        Urgent Renewal
                      </Button>
                    </Box>
                  )
                })
              )}
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const renderContent = () => {
    // Live Tracking menu removed from school portal
    if (activeMenu === 'dashboard') {
      return renderDashboard();
    }
    
    if (activeMenu === 'students') {
      switch (activeSubmenu) {
        case 'all-students':
          return renderStudents();
        case 'add-student':
          return renderAddStudent();
        case 'edit-student':
          return renderEditStudent();
        case 'import-students':
          return renderImportStudents();
        default:
          return renderStudents();
      }
    }
    
    if (activeMenu === 'settings') {
      switch (activeSubmenu) {
        case 'add-standard':
          return renderAddStandard();
        case 'add-division':
          return renderSettingsAddDivision();
        case 'class-teachers':
        case 'add-teacher':
        case 'assign-teacher':
          return renderAssignTeacher();
        case 'school-profile':
          return renderSchoolProfile();
        default:
          return renderSchoolProfile();
      }
    }
    
    if (activeMenu === 'devices') {
      switch (activeSubmenu) {
        case 'all-devices':
          return renderAllDevices();

        case 'edit-device':
          return renderEditDevice();
        case 'import-devices':
          return renderImportDevices();
        case 'device-assignment':
          return renderDeviceAssignment();
        case 'device-unassignment':
          return renderDeviceUnassignment();
        default:
          return renderAllDevices();
      }
    }
    
    if (activeMenu === 'subscription') {
      switch (activeSubmenu) {
        case 'payment-collection':
          return renderPaymentCollection();
        case 'subscription-status':
          return renderSubscriptionStatus();
        case 'payment-reports':
          return renderPaymentReports();
        case 'renewal-reminders':
          return renderRenewalReminders();
        default:
          return renderPaymentCollection();
      }
    }
    
    if (activeMenu === 'commission') {
      return renderCommissionContent();
    }

    if (activeMenu === 'sales') {
      return renderDeviceSalesReport();
    }
    
    if (activeMenu === 'parents') {
      switch (activeSubmenu) {
        case 'parent-accounts':
          return renderParentAccounts();
        case 'create-parent-login':
          return renderCreateParentLogin();
        case 'assign-students-to-parent':
          return renderAssignStudentsToParent();
        case 'reset-parent-password':
          return renderResetParentPassword();
        case 'parent-notifications':
          return renderParentNotifications();
        default:
          return renderParentAccounts();
      }
    }
    
    return (
      <Box sx={{ flexGrow: 1, p: 3, textAlign: 'center' }}>
        <Icon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }}>construction</Icon>
        <Typography variant="h4" color="textSecondary" gutterBottom>
          Coming Soon
        </Typography>
        <Typography variant="body1" color="textSecondary">
          This feature is under development.
        </Typography>
      </Box>
    );
  };

  const drawer = (
    <Box>
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="h6" fontWeight="bold" sx={{ color: '#fff' }}>
          Track My Child
        </Typography>
      </Box>
      <Divider />
      <List>
        {menuItems.map((item) => (
          <Fragment key={item.id}>
            <ListItem disablePadding>
              <ListItemButton
                selected={activeMenu === item.id && !item.submenu}
                onClick={() => {
                  if (item.id === 'commission') {
                    if (!requestCommissionAccess({ menu: 'commission', submenu: 'commission-summary' })) {
                      return;
                    }
                  }
                  if (item.submenu) {
                    setExpandedMenus({ [item.id]: !expandedMenus[item.id] });
                  }
                  setActiveMenu(item.id);
                }}
                sx={{
                  '&.Mui-selected': {
                    bgcolor: 'primary.main',
                    color: 'white',
                    '&:hover': {
                      bgcolor: 'primary.dark',
                    },
                    '& .MuiListItemIcon-root': {
                      color: 'white',
                    },
                  },
                }}
              >
                <ListItemIcon>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.label} />
                {item.submenu && (
                  expandedMenus[item.id] ? <ExpandLess /> : <ExpandMore />
                )}
              </ListItemButton>
            </ListItem>
            {item.submenu && (
              <Collapse in={expandedMenus[item.id]} timeout="auto">
                <List component="div" disablePadding>
                  {item.submenu.map((subitem) => (
                    <ListItemButton
                      key={subitem.id}
                      selected={activeSubmenu === subitem.id}
                      onClick={() => {
                        if (item.id === 'commission' || String(subitem.id).startsWith('commission-')) {
                          if (!requestCommissionAccess({ menu: item.id, submenu: subitem.id })) {
                            return;
                          }
                        }
                        setActiveSubmenu(subitem.id);
                        setActiveMenu(item.id);
                      }}
                      sx={{
                        pl: 4,
                        '&.Mui-selected': {
                          bgcolor: 'primary.light',
                          color: 'white',
                        },
                      }}
                    >
                      <ListItemText primary={subitem.label} />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            )}
          </Fragment>
        ))}
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={() => { clearCommissionUnlock(); onLogout(); }}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          bgcolor: 'white',
          color: 'text.primary',
          boxShadow: 1
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={() => setMobileOpen(!mobileOpen)}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            {menuItems.find(item => item.id === activeMenu)?.label}
          </Typography>
          <IconButton color="inherit">
            <SearchIcon />
          </IconButton>
          <IconButton
            color="inherit"
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <AccountIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem onClick={() => setAnchorEl(null)}>
              <Typography variant="body2">{user.name}</Typography>
            </MenuItem>
            <MenuItem onClick={onLogout}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          mt: 8
        }}
      >
        {renderContent()}
      </Box>

      {/* Change Password Dialog */}
      <Dialog
        open={changePasswordDialog}
        onClose={() => setChangePasswordDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Change Password
          <IconButton
            onClick={() => setChangePasswordDialog(false)}
            sx={{ color: 'grey.500' }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ p: 2 }}>
            <form onSubmit={handleChangePassword}>
              <TextField
                fullWidth
                label="Current Password"
                type="password"
                variant="outlined"
                margin="normal"
                value={passwordForm.current_password}
                onChange={(e) => setPasswordForm({...passwordForm, current_password: e.target.value})}
                required
              />
              <TextField
                fullWidth
                label="New Password"
                type="password"
                variant="outlined"
                margin="normal"
                value={passwordForm.new_password}
                onChange={(e) => setPasswordForm({...passwordForm, new_password: e.target.value})}
                required
                helperText="Minimum 6 characters"
              />
              <TextField
                fullWidth
                label="Confirm New Password"
                type="password"
                variant="outlined"
                margin="normal"
                value={passwordForm.confirm_password}
                onChange={(e) => setPasswordForm({...passwordForm, confirm_password: e.target.value})}
                required
              />
              <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                <Button 
                  variant="outlined" 
                  onClick={() => setChangePasswordDialog(false)}
                >
                  Cancel
                </Button>
                <Button 
                  variant="contained" 
                  type="submit"
                  color="primary"
                >
                  Change Password
                </Button>
              </Box>
            </form>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Payment Details Dialog */}
      <Dialog
        open={paymentDetailsDialog}
        onClose={() => setPaymentDetailsDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Payment Details
          <IconButton
            onClick={() => setPaymentDetailsDialog(false)}
            sx={{ color: 'grey.500' }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedPayment && (
            <Box sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom color="primary">
                Student Information
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Name:</strong> {selectedPayment.first_name} {selectedPayment.last_name}
              </Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                <strong>Class:</strong> {selectedPayment.standard} - {selectedPayment.division}
              </Typography>
              
              <Typography variant="h6" gutterBottom color="primary">
                Payment Information
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Amount:</strong> ₹{selectedPayment.amount}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Payment Method:</strong> {selectedPayment.payment_method}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Payment Date:</strong> {new Date(selectedPayment.payment_date).toLocaleDateString()}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Plan:</strong> {selectedPayment.plan_name}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Status:</strong> <Chip label="Completed" color="success" size="small" />
              </Typography>
              
              <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 2 }}>
                Subscription Period
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Start Date:</strong> {selectedPayment.subscription_start_date ? new Date(selectedPayment.subscription_start_date).toLocaleDateString() : 'N/A'}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>End Date:</strong> {selectedPayment.subscription_end_date ? new Date(selectedPayment.subscription_end_date).toLocaleDateString() : 'N/A'}
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Reset Password Dialog */}
      <Dialog open={resetPasswordDialog} onClose={() => setResetPasswordDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Reset Password - {resetPasswordForm.parentName}</DialogTitle>
        <DialogContent>
          <Box sx={{ p: 2 }}>
            <TextField 
              fullWidth 
              label="New Password" 
              type="password" 
              value={resetPasswordForm.newPassword}
              onChange={(e) => setResetPasswordForm(prev => ({...prev, newPassword: e.target.value}))}
              helperText="Minimum 6 characters required"
              sx={{ mb: 2 }} 
            />
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button variant="outlined" onClick={() => {
                setResetPasswordDialog(false);
                setResetPasswordForm({ parentId: '', parentName: '', newPassword: '' });
              }}>Cancel</Button>
              <Button 
                variant="contained" 
                onClick={handleResetPassword}
                disabled={loading || !resetPasswordForm.newPassword || resetPasswordForm.newPassword.length < 6}
              >
                {loading ? 'Resetting...' : 'Reset Password'}
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Edit Parent Dialog */}
      <Dialog open={editParentDialog} onClose={() => setEditParentDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Parent Account</DialogTitle>
        <DialogContent>
          <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="First Name"
                  value={editParentForm.firstName}
                  onChange={(e) => setEditParentForm(prev => ({...prev, firstName: e.target.value}))}
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Last Name"
                  value={editParentForm.lastName}
                  onChange={(e) => setEditParentForm(prev => ({...prev, lastName: e.target.value}))}
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Email"
                  type="email"
                  value={editParentForm.email}
                  onChange={(e) => setEditParentForm(prev => ({...prev, email: e.target.value}))}
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Phone"
                  value={editParentForm.phone}
                  onChange={(e) => setEditParentForm(prev => ({...prev, phone: e.target.value}))}
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={editParentForm.status}
                    label="Status"
                    onChange={(e) => setEditParentForm(prev => ({...prev, status: e.target.value}))}
                  >
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" sx={{ mb: 2 }}>Assigned Students ({editParentForm.assignedStudents.length})</Typography>
                <Box sx={{ border: 1, borderColor: 'grey.300', borderRadius: 1, maxHeight: 200, overflow: 'auto', p: 1 }}>
                  {editParentForm.assignedStudents.length === 0 ? (
                    <Typography variant="body2" color="textSecondary" sx={{ p: 2, textAlign: 'center' }}>
                      No students assigned
                    </Typography>
                  ) : (
                    editParentForm.assignedStudents.map(student => (
                      <Box
                        key={student.id}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          p: 1,
                          borderBottom: 1,
                          borderColor: 'grey.200'
                        }}
                      >
                        <Box>
                          <Typography variant="body2" fontWeight="bold">
                            {student.first_name} {student.last_name}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {student.standard} - {student.division} (Roll: {student.roll_number})
                          </Typography>
                        </Box>
                        <Button
                          size="small"
                          color="error"
                          onClick={async () => {
                            if (window.confirm(`Remove ${student.first_name} ${student.last_name} from this parent?`)) {
                              try {
                                const token = localStorage.getItem('authToken');
                                const response = await fetch(`${API_BASE_URL}/school/unassign-student-from-parent`, {
                                  method: 'POST',
                                  headers: {
                                    'Authorization': `Bearer ${token}`,
                                    'Content-Type': 'application/json'
                                  },
                                  body: JSON.stringify({
                                    student_id: student.id
                                  })
                                });
                                
                                if (response.ok) {
                                  setEditParentForm(prev => ({
                                    ...prev,
                                    assignedStudents: prev.assignedStudents.filter(s => s.id !== student.id)
                                  }));
                                  alert('Student removed successfully!');
                                } else {
                                  alert('Failed to remove student');
                                }
                              } catch (error) {
                                alert('Error removing student');
                              }
                            }
                          }}
                        >
                          Remove
                        </Button>
                      </Box>
                    ))
                  )}
                </Box>
              </Grid>
            </Grid>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 2 }}>
              <Button variant="outlined" onClick={() => setEditParentDialog(false)}>Cancel</Button>
              <Button variant="contained" onClick={handleUpdateParent} disabled={loading}>
                {loading ? 'Updating...' : 'Update Parent'}
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Notification Dialog */}
      <Dialog open={notificationDialog} onClose={() => setNotificationDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Send Notification</DialogTitle>
        <DialogContent>
          <Box sx={{ p: 2 }}>
            <TextField fullWidth label="Title" sx={{ mb: 2 }} />
            <TextField fullWidth label="Message" multiline rows={4} sx={{ mb: 2 }} />
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button variant="outlined" onClick={() => setNotificationDialog(false)}>Cancel</Button>
              <Button variant="contained" onClick={handleSendNotification}>Send</Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Add Parent Dialog */}
      <Dialog
        open={parentDialog}
        onClose={() => setParentDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Add Parent
          <IconButton
            onClick={() => setParentDialog(false)}
            sx={{ color: 'grey.500' }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Parent Email"
                  type="email"
                  required
                  value={parentForm.email}
                  onChange={(e) => {
                    handleParentFormChange('email', e.target.value);
                    if (e.target.value) {
                      checkParentExists(e.target.value);
                    }
                  }}
                  onBlur={() => checkParentExists(parentForm.email)}
                />
                {parentExists && (
                  <Typography variant="caption" color="success.main">
                    ✓ Parent found! Details auto-filled.
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="First Name"
                  required
                  value={parentForm.firstName}
                  onChange={(e) => handleParentFormChange('firstName', e.target.value)}
                  disabled={parentExists}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Last Name"
                  required
                  value={parentForm.lastName}
                  onChange={(e) => handleParentFormChange('lastName', e.target.value)}
                  disabled={parentExists}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Phone Number"
                  required
                  value={parentForm.phone}
                  onChange={(e) => handleParentFormChange('phone', e.target.value)}
                  disabled={parentExists}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Address"
                  multiline
                  rows={2}
                  value={parentForm.address}
                  onChange={(e) => handleParentFormChange('address', e.target.value)}
                  disabled={parentExists}
                />
              </Grid>
              {!parentExists && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Password"
                    type="password"
                    required
                    value={parentForm.password}
                    onChange={(e) => handleParentFormChange('password', e.target.value)}
                    helperText="Password for parent login access"
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                  <Button
                    variant="outlined"
                    onClick={() => setParentDialog(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      // Store parent info for student registration
                      setStudentForm(prev => ({
                        ...prev,
                        parentEmail: parentForm.email,
                        parentName: `${parentForm.firstName} ${parentForm.lastName}`,
                        parentMobile1: parentForm.phone // Auto-fill parent mobile from parent form
                      }));
                      setParentDialog(false);
                      alert('Parent information saved! Mobile number auto-filled. It will be linked when you submit the student.');
                    }}
                    disabled={!parentForm.email || !parentForm.firstName || !parentForm.lastName || !parentForm.phone || (!parentExists && !parentForm.password)}
                  >
                    {parentExists ? 'Link Parent' : 'Add Parent'}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog open={commissionOtpOpen} onClose={() => { setCommissionOtpOpen(false); setActiveMenu('dashboard'); }}>
        <DialogTitle>Commission Access OTP</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Enter the commission OTP to view commission pages. Invalid OTP returns you to the dashboard.
          </Typography>
          <TextField
            fullWidth
            label="OTP"
            type="password"
            value={commissionOtp}
            onChange={(e) => setCommissionOtp(e.target.value)}
            error={Boolean(commissionOtpError)}
            helperText={commissionOtpError || ' '}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1 }}>
            <Button onClick={() => { setCommissionOtpOpen(false); setActiveMenu('dashboard'); }}>Cancel</Button>
            <Button variant="contained" onClick={submitCommissionOtp}>Verify</Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default SchoolDashboard;